import React, { useEffect, useState, useRef } from 'react'
import {
  CFormTextarea,
  CCard,
  CButton,
  CSpinner,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CCardBody,
  CFormInput,
  CFormLabel,
  CForm,
  CRow,
  CCol,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CBadge,
  CCardSubtitle,
} from '@coreui/react'
import Select from 'react-select'
import MedicationTable from './MedicationTable'
import { Form, Formio } from '@formio/react'
import GetQuestionBank from '../../services/general/saveQuestionBank.api'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import HighlightedText from './../../components/shared/HighlightedText'
import LabDisplayComponent from './LabDisplayComponent'
import ModifyPatientHistory from '../../services/general/modifyPatientHistory.api'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import CustomAccordionComponent from '../../components/shared/CustomAccordionComponent'
import MedicineCRUD from '../../services/general/Medication.api'
import FinalNoteDisplayImaging from './FinalNoteDisplayImaging'
import AsseseementFinalNote from './Asseseement'
import PatientQuestionPoa from './PatientQuestionPoa'
import NoteMedicationsDisplay from './NoteMedicationsDisplay'
import MorseBimsScore from '../../components/shared/MorseBimsScore'
import HPIQuestions from './HPIQuestions'
import { usePDF } from 'react-to-pdf'

import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import SaveExtra from '../../../src/services/general/saveExtraData.api'
import fetchPatientData from '../../../src/services/general/patientGeneralAPI.api'
import Carder from '../../../src/components/shared/Carder'
import ShowHpiPatientInNoteView from './ShowHpiPatientInNoteView'
import MorseScore from '../../components/shared/MorseScore'
import FacilityCRUD from '../../../src/services/general/getFacilityData.api'
import Graytextarea from '../../../src/components/Graytextarea'
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, Table, Video, Audio, PasteCleanup, ImportExport } from '@syncfusion/ej2-react-richtexteditor'
import PESelectedData from './PESelectedData'
import GESelectedData from '../../utils/GESelectedData.json'
import axios from 'axios'
import PatientPhysicalExaminationData from '../../../src/services/general/physicalExaminationData.api'
import PatientOrdersCRUD from '../../../src/services/general/patientOrders.api'
import Loader from '../../../src/components/shared/Loader'
import { cifKg } from '@coreui/icons'
import PatientAppointmentDetails from '../../../src/services/general/appointmentData.api'
import { getAllAppointments, getAllAppointmentsDetails } from '../../../src/components/shared/appointmentFilterData'
import { useIndexedDB } from '../../context/IndexedContext'

export const physicalExaminationData = GESelectedData.data

const ProviderLsPatientNoteViewFreetype = ({
  peAdded,
  setPEAdded,
  rosAdded,
  setRosAdded,
  hpiAdded = false,
  addedNewIncident,
  setAddedNewIncident,
  setHpiAdded,
  allLabs,
  statusPatientNoteWasFollowUp,
  setRowClicked,
  hpiHeading = '',
  setAppointmentDetails = false,
  showDataIfNoteIsFollowUp,
  patientID,
  setDataId,
  showToolbar = true,
  showMedicationLikeApp,
  showHrsInTreatment,
  showTreatmentAsAccordion,
  diagnosisCode,
  selectedRisks,
  setSelectedRisks,
  MasterDiagnosisData,
  noteStructureRef,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  patientData,
  patientTreatments,
  hospitalRecords,
  patientDiagnosis,
  diagnosisAddedPinger,
  setHospitalRecords,
  patientSidebarActiveTab,
  allergies,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  setImaging,
  activeTab,
  imagingTypeList,
  selectedDifferentialDiagnosis,
  noteShow,
  noteID,
  addendumData,
  onlyShowHTmlService = true,
  patientDBData,
  changesInTreatmentShell,
  setChangesInTreatmentShell,
  noteCallType,
}) => {
  console.log(personalHistory, 'personalHistory rishi')
  const [modalVisible, setModalVisible] = useState(false)
  const [diagnosis, setDiagnosis] = useState([])
  const [visible, setVisible] = useState(false)
  const [newQuestions, setNewQuestions] = useState([])
  const [formAnswers, setFormAnswers] = useState([])
  const newAnswers = useRef([])
  const [questions, setQuestions] = useState([])
  const [HPIRemarks, setHPIRemarks] = useState('')
  const [diagnosisMedicationMap, setDiagnosisMedicationMap] = useState({})
  const [diagnosisLabMap, setDiagnosisLabMap] = useState({})
  const [diagnosisKeywords, setDiagnosisKeywords] = useState([])
  const [riskfactors, setRiskFactors] = useState({})
  // const [selectedRisks, setSelectedRisks] = useState([]);
  const [allHistoriesList, setAllHistoriesList] = useState([])
  const [masterMedications, setMasterMedications] = useState([])
  const [peData, setPeData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const [currentNoteData, setCurrentNoteData] = useState({})
  const [fetchAllergy, setFetchAllergy] = useState([])

  const {
    getOfflineData,
    getPOACMaster,
    getProviderDetails,
    getMedicationMasterData,
    getFacilityData,
    getHPIDiagnosisData,
    getAllMasterDiagnosis,
    getCallCenterQuestions,
    getPatientHpi,
    savePatientHpi,
    getAllMasterDiagnosisOptions,
    getDiagnosisReponseData,
    getRiskFactorMaster,
    getGeneralPlanStatement,
  } = useIndexedDB()

  console.log(noteStructureRef, 'notestrcure ref patientTreatments', patientTreatments, patientDiagnosis, showDataIfNoteIsFollowUp)

  console.log(peAdded, 'peAdded ->>>>')

  useEffect(() => {
    const fetchOfflineData = async () => {
      setCurrentNoteData(patientDBData?.currentNote?.data)
    }
    fetchOfflineData()
  }, [loggedUserProvider, hpiAdded])

  useEffect(() => {
    const getProvidr = async () => {
      const loggedUserID = await getProviderDetails()
      setLoggedUserProvider(loggedUserID || {})
    }
    getProvidr()
  }, [])

  console.log(loggedUserProvider, 'loggedUserProvider')

  const toggleRiskSelection = (risk) => {
    setSelectedRisks((prevState) => (prevState.includes(risk) ? prevState.filter((r) => r !== risk) : [...prevState, risk]))
  }

  const fetchAllergies = async () => {
    try {
      let formattedData
      let withoutSorted

      formattedData = patientDBData?.patientAllergy || []
      if (formattedData) {
        withoutSorted = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }

      setFetchAllergy(formattedData?.reverse())
      return formattedData?.reverse()
    } catch (error) {
      console.log(error)
      toast.error('Error fetching allergies', toastConfig)
    }
  }

  useEffect(() => {
    fetchAllergies()
  }, [])

  const filterEmptyData = (data) => {
    return data
      .map((item) => {
        const filteredData = item.data
          .map((dataItem) => {
            const filteredDataItem = {}

            for (const [key, value] of Object.entries(dataItem)) {
              // Skip if value is empty string
              if (value === '') {
                continue
              }

              // Skip if value is empty array
              if (Array.isArray(value) && value.length === 0) {
                continue
              }

              // Keep the property if it's not empty
              filteredDataItem[key] = value
            }

            return filteredDataItem
          })
          .filter((dataItem) => Object.keys(dataItem).length > 0) // Remove completely empty objects

        return {
          ...item,
          data: filteredData,
        }
      })
      .filter((item) => item.data.length > 0) // Remove items with no data
  }

  const getRisks = async (diagnosisList) => {
    // let responseRisks = await GetDiagnosisData('Risks')

    try {
      // risks = JSON.parse(risks);
      const risks = await getRiskFactorMaster()
      // let risks = JSON.parse(responseRisks.d)?.Data

      // let  = localStorage.getItem("Risks")
      let allRisks = {}

      // Iterate over each diagnosis

      diagnosisList?.forEach((diagnosis) => {
        // Find the risk object that matches the diagnosis name

        let riskObj = risks.find((obj) => obj.Name.trim() == diagnosis.trim())

        if (riskObj) {
          // Assign the risks to the corresponding diagnosis name in the allRisks object
          allRisks[diagnosis] = riskObj.RiskFactors.split(',')
        } else {
          // If no risks found for the diagnosis, you can initialize it as an empty array or handle it accordingly
          allRisks[diagnosis] = []
        }
      })

      setRiskFactors(allRisks)
    } catch (e) {
      console.error('Failed to parse risks from local storage', e)
    }
  }

  // setRowClicked

  const [patientExtraData, setPatientExtraData] = useState({})
  console.log(patientExtraData, 'patientExtraDatapatientExtraDatapatientExtraData')

  const getAppointmentDetails = async () => {
    console.log(setAppointmentDetails, 'setAppointmentDetails')
    // if(!setAppointmentDetails) {
    //     console.log(setDataId,'noteStructureRef.current when setAppointmentDetails is null')
    //     setPatientExtraData({
    //             providerAssigned : noteStructureRef.current?.appointmentDetails?.data?.ProviderName || "",
    //             patientTerm : noteStructureRef.current?.appointmentDetails?.data?.term || "",
    //             scheduleStartTime : noteStructureRef.current?.appointmentDetails?.data?.StartTime || "",
    //         })
    //         console.log(patientExtraData,'patientExtraData when setAppointmentDetails is null')
    //     return
    // };
    try {
      // const structuredData = await getAllAppointmentsDetails('GET')
      //   const findAppointment = structuredData.find((item) => item?.data?.PatientID === patientData.PatientID && (item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled') && item?.data?.NoteID === setDataId)
      // const findAppointment = structuredData.find(
      //   (item) => item?.data?.PatientID === patientData?.PatientID && item?.data?.NoteID === setDataId,
      //   // && (item?.data?.Status === "Scheduled" || item?.data?.Status === "Rescheduled")
      //   //  && (item?.data?.Status === "Scheduled" || item?.data?.Status === "Rescheduled")
      //   //  && item?.data?.NoteID === setDataId
      // )

      const findAppointment = patientDBData?.appointmentData

      // if (findAppointment) {
      //   setPatientExtraData({
      //     providerAssigned: findAppointment?.data?.ProviderName || '',
      //     patientTerm: findAppointment?.data?.term || '',
      //     scheduleStartTime: findAppointment?.data?.StartTime || '',
      //   })
      // }
      if (findAppointment) {
        setPatientExtraData({
          providerAssigned: findAppointment?.ProviderName || '',
          patientTerm: findAppointment?.term || '',
          scheduleStartTime: findAppointment?.StartTime || '',
        })
      }
    } catch (error) {
      console.log(error)
    }
    // if (findIsThereAnySubmiitedOrSigned) {
    // const findAppointment = appointment.find((item) => item?.data?.PatientID === patient?.PatientID)
    // console.log(findAppointment, patient, 'findAppointment')

    // if (findAppointment) {
    //   const noteIdForthisAppointment = findAppointment?.data?.NoteID
    //   const findNote = parsedData.find((item) => item?.id === noteIdForthisAppointment)
    //   console.log(findNote, findAppointment, patient, 'findNotefindNotefindNote')
    //   if (findNote) {
    //     status = findNote?.status || status
    //     flag = findNote?.flag || 'false'
    //   }
    // }
  }

  console.log(showDataIfNoteIsFollowUp, 'showDataIfNoteIsFollowUp')

  useEffect(() => {
    getAppointmentDetails()
  }, [])

  const formioOptions = {
    readOnly: true,
    renderMode: 'html',
  }
  const AddDiagnosis = () => {
    setVisible(true)
  }
  const HPIButtons = [{ name: '+ Add Diagnosis', fn: AddDiagnosis }]

  const historyMapping = {
    pmhx: 'Past Medical History',
    pshx: 'Past Surgical History',
    fh: 'Family History',
    sh: 'Social History',
  }
  const formatDate = (inputDate) => {
    if (!inputDate) return ''
    const dateObj = new Date(inputDate)
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0')
    const dd = String(dateObj.getDate()).padStart(2, '0')
    const yyyy = dateObj.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const formData = useRef([])
  const [diagnosisData, setDiagnosisData] = useState([])

  const getDataDiagnosis = async () => {
    // let a = await GetDiagnosisData()
    const a = await getDiagnosisReponseData()

    console.log(a, 'getDiagnosisReponseData')

    let data = JSON.parse(a.d)
    let options = []
    let keywords = []
    const ls = await getAllMasterDiagnosisOptions()
    data.Data.map((obj) => {
      if (obj.Keywords && obj.Keywords != '') {
        let keywordList = obj.Keywords.split(',')
        keywords.push(...keywordList)
      }

      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })

    console.log(ls, 'diagnosis data option in ls', keywords, options)
    setDiagnosisKeywords(keywords)
    setDiagnosisData(options)
  }

  var selectedDiagnosis = 0

  const diagnosisChanged = async (e) => {
    selectedDiagnosis = e.label
  }

  const handleModalSave = async () => {
    try {
      let newDiagnosis = selectedDiagnosis
      setDiagnosis((prevDiagnosis) => [...prevDiagnosis, newDiagnosis])
      try {
        let c = await GetQuestionBank('', newDiagnosis, '')
        let component = JSON.parse(c?.d)

        let temp = [component]

        setNewQuestions((prev) => [...prev, component])

        newAnswers.current.push([])
      } catch (e) {}
    } catch (e) {
      console.log('Error Saving Diagnosis Data', e.Message)
    }

    setVisible(false)
  }

  useEffect(() => {
    getDataPersonalHistoryInNote()
  }, [patientID])

  console.log(personalHistory, 'personalHistory')

  const [allTreamentStatements, setAllTreatmentStatements] = useState({})
  const getTreatmentPlansData = async () => {
    // let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
    // data = JSON.parse(data.d)?.Data || []
    const sturcturedTreatments = {}
    const data = await getGeneralPlanStatement()
    if (data) {
      patientDiagnosis.forEach((diagnosis) => {
        const matched = data?.length > 0 && data?.find((item) => item.Data?.diagnosis?.label === diagnosis)
        if (matched) {
          const suggestionNames = matched.Data.accordions.flatMap((accordion) => accordion?.suggestions?.suggestionName || []).map((s) => s.name)
          const joinedStatements = suggestionNames?.join('\n')
          sturcturedTreatments[diagnosis] = joinedStatements
        }
      })
      setAllTreatmentStatements(sturcturedTreatments)
    }
  }

  useEffect(() => {
    getTreatmentPlansData()
  }, [patientDiagnosis])

  // const getDataPersonalHistoryInNote = async () => {
  //   let history = {}

  //   for (const [key, value] of Object.entries(historyObjectKeysParticular)) {
  //     let allData = await getPatientPersonalHistory('GET', patientID, value, '')

  //     const formattedData = JSON.parse(allData?.d)

  //     history[key] = formattedData?.Data
  //   }

  //   setPersonalHistory(history)
  // }

  const getDataPersonalHistoryInNote = async () => {
    console.log('internalNote', patientDBData)

    setPersonalHistory(patientDBData?.patientHistories || {})
  }

  useEffect(() => {
    const metadata = noteStructureRef?.current?.metadata || {}

    console.log(personalHistory, metadata, 'personalHistory')

    const allHistories = Object.keys(personalHistory)
      .map((key) => {
        const histories = personalHistory[key] || []
        const matchingEntry = histories.find((item) => item.Id === metadata[historyObjectKeysParticular[key]])
        console.log(
          metadata[historyObjectKeysParticular[key]],
          histories,
          histories.find((item) => item.Id === metadata[historyObjectKeysParticular[key]]),
          'medical issue',
        )
        return matchingEntry
          ? {
              key: historyObjectKeysParticular[key],
              heading: historyMapping[key],
              entry: matchingEntry[historyObjectKeysParticular[key]],
            }
          : null
      })
      .filter(Boolean) // remove nulls

    setAllHistoriesList(allHistories)
  }, [personalHistory])

  const getCallCenterData = async (diagnosisList) => {
    setLoading(true)
    let newComponents = []
    let tempAnswers = patientDBData?.tempAnswersGetPatientDiagnosisDetails

    // let tempAnswers = await GetPatientDiagnosisDetails(patientData.PatientID)
    try {
      let data = JSON.parse(tempAnswers.d)
      let formAnswersStr = data.Data[0].DiagnosisDetails
      let tempData = JSON.parse(formAnswersStr)

      setFormAnswers(tempData)
    } catch (e) {}
    for (let a = 0; a < diagnosisList?.length; a++) {
      try {
        formData.current.push([])
        try {
          let component = []
          const POACMaster = await getPOACMaster()
          // let c = await GetQuestionBank("", diagnosisList[a], "")
          let c = POACMaster[diagnosisList[a]]

          component = JSON.parse(c?.d)
          newComponents.push(component)
        } catch (e) {}
      } catch (e) {
        console.log('Error Fetching Diagnosis Data: ', diagnosisList[a], e)
      }
    }
    setQuestions(newComponents)
    setLoading(false)
  }

  const sortImagingData = (data) => {
    const sortedByPriority = data.sort((a, b) => {
      // Compare by priority
      if (a.priority !== b.priority) {
        return a.priority - b.priority
      }
      // If priority is the same, compare by date
      return new Date(b.date) - new Date(a.date)
    })
    return sortedByPriority
  }

  const groupImagingByDiagnosis = (imagingData) => {
    const groupedData = {}
    const diagnosisMap = {}
    diagnosisData.forEach((d) => {
      diagnosisMap[d.value] = d.label
    })
    imagingData.forEach((imaging) => {
      imaging.otherDetails.forEach((detail) => {
        const diagnosisName = diagnosisMap[detail.diagnosis]
        if (diagnosisName) {
          if (!groupedData[diagnosisName]) {
            groupedData[diagnosisName] = []
          }
          groupedData[diagnosisName].push({
            date: imaging.date,
            impression: imaging.impression,
            keywords: imaging.keywords,
            name: imaging.name,
            remark: detail.remarks,
          })
        }
      })
    })
    return groupedData
  }

  function createDiagnosisMedicationMap(data) {
    const diagnosisMedicationMap = {}

    const entryDate = data.date
    for (const medication of data.medications) {
      if (medication.diagnosis) {
        const diagnoses = medication.diagnosis.split(',')

        for (const diagnosis of diagnoses) {
          if (!diagnosisMedicationMap[diagnosis]) {
            diagnosisMedicationMap[diagnosis] = {
              date: entryDate,
              medications: [],
            }
          }
          diagnosisMedicationMap[diagnosis].medications.push(medication)
        }
      }
    }

    return diagnosisMedicationMap
  }

  const filterLabsByDiagnosis = (labs) => {
    const diagnosisGroups = {}

    labs?.forEach((labEntry) => {
      labEntry.labs.forEach((lab) => {
        if (lab.diagnosis) {
          const diagnoses = lab.diagnosis.split(',')
          const labDate = new Date(labEntry.date)

          diagnoses.forEach((diagnosis) => {
            diagnosis = diagnosis.trim()
            if (!diagnosisGroups[diagnosis]) {
              diagnosisGroups[diagnosis] = { date: labEntry.date, labs: [lab] }
            } else {
              const existingDate = new Date(diagnosisGroups[diagnosis].date)
              if (labDate > existingDate) {
                diagnosisGroups[diagnosis] = { date: labEntry.date, labs: [lab] }
              } else if (labDate.getTime() === existingDate.getTime()) {
                diagnosisGroups[diagnosis].labs.push(lab)
              }
            }
          })
        }
      })
    })

    return diagnosisGroups
  }

  const getLabs = () => {
    let noteLabs = localStorage.getItem('notesLabs')
    try {
      let labs = JSON.parse(noteLabs)

      if (labs) {
        let diagnosisMap = filterLabsByDiagnosis(labs)
        setDiagnosisLabMap(diagnosisMap)
      }
    } catch (e) {}
  }

  const getMedication = () => {
    //     const storedMedications = JSON.parse(localStorage.getItem('patientMedications')) || {};
    //     setMedication(storedMedications[patientID] || []);
    //     let patientMedication = storedMedications[patientID] || []
    //     localStorage.setItem("allMedication", JSON.stringify(patientMedication.length > 0 ? patientMedication[patientMedication.length - 1] : {})) //both dooing the same thing
  }

  useEffect(() => {
    getMedication()
    getLabs()
  }, [diagnosisData.length])

  // const getHistory = async () => {
  //   let allData = await ModifyPatientHistory('GET', patientID)
  //   let history = JSON.parse(allData?.d)
  //   setHospitalRecords(history?.Data)
  //   let allHistory = history?.Data
  //   if (allHistory.length > 0) {
  //     localStorage.setItem('PatientHospitalRecords', allHistory[allHistory.length - 1].History)
  //   } else {
  //     localStorage.setItem('PatientHospitalRecords', '')
  //   }
  // }

  const getHistory = async () => {
    console.log('internalNote', patientDBData?.hospitalRecords)
    setHospitalRecords(patientDBData?.hospitalRecords?.Data || [])
    let allHistory = patientDBData?.hospitalRecords?.Data || []
    if (allHistory.length > 0) {
      localStorage.setItem('PatientHospitalRecords', allHistory[allHistory.length - 1].History)
    } else {
      localStorage.setItem('PatientHospitalRecords', '')
    }
  }

  useEffect(() => {
    setLoading(true)
    getHistory()
    getDataDiagnosis()
    let diagnosis = patientData?.Diagnosis
    let diagnosisList = diagnosis?.split(',')
    setDiagnosis(diagnosisList)

    getCallCenterData(diagnosisList)
    getRisks(diagnosisList)
    GetMasterMedications()
    setLoading(false)
  }, [patientID, diagnosisAddedPinger])

  // const getAllergies = () => {
  //     try {
  //         const storedData = JSON.parse(localStorage.getItem('patientAllergies')) || {};
  //         const patientAllergies = storedData[patientID] || []
  //         setAllergies(patientAllergies);
  //         let temp = []
  //         if (storedData[patientID] && storedData[patientID].length > 0) {
  //             temp = storedData[patientID]
  //         }
  //         localStorage.setItem('noteAllergies', JSON.stringify(temp));
  //     } catch (e) {
  //     }
  // }

  // get master medications
  const GetMasterMedications = async () => {
    try {
      // let allMedicines = await MedicineCRUD('GET')
      // let formattedData = JSON.parse(allMedicines.d)?.Data
      // if (formattedData) {
      //   formattedData = formattedData.map((item) => {
      //     let itemData = JSON.parse(item.Data)
      //     return {
      //       ...item,
      //       Data: {
      //         ...itemData,
      //         diagnoses: itemData.diagnoses.split(',').map((diagnosis) => diagnosis.trim()),
      //       },
      //     }
      //   })
      //     setMasterMedications(formattedData)
      //  }
      const allMedication = await getMedicationMasterData()
      if (allMedication) {
        setMasterMedications(allMedication || [])
      }
    } catch (error) {
      console.error('Error fetching master medications:', error)
    }
  }

  const getDiagnosisMedicationInRisk = (diagnosisName) => {
    if (masterMedications.length > 0) {
      const lastMedicationAdded = medication[medication.length - 1]
      if (!lastMedicationAdded) return
      const { data } = lastMedicationAdded
      const matchingDiagnoses = data.map((med) => {
        const matchingMasterMed = masterMedications.find((item) => item.Data?.name === med.name)
        return matchingMasterMed
      })
      let name
      matchingDiagnoses.find((item) => {
        if (item?.Data.diagnoses.includes(diagnosisName)) {
          name = item.Data
        }
      })
      noteStructureRef.current = {
        ...noteStructureRef.current,
      }
      return name // we are shouwing the data of master medication which doesn't has any date.
    } else {
      return 'Not enough information'
    }
  }

  const hasAnyAnswer = (data) => {
    return Object.values(data).some((value) => {
      return typeof value === 'string' && value.trim() !== ''
    })
  }

  // Pdf part
  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' })

  // Provider Final Note Part

  const [patientFinalNoteHpi, setPatientFinalNoteHpi] = useState({})
  const [patientHpiOtherData, setPatientHpiOtherData] = useState({
    medicationRemarksForSubjective: '',
    data: '',
  })

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }
  const [subjective, setSubjective] = useState([])

  console.log(subjective, 'subjectivesubjectivesubjective')

  const [newFreeTypeText, setNewFreeTypeText] = useState('')
  const fetchPatientFinalNoteDetails = async () => {
    try {
      // let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      // let allData = JSON.parse(data?.d)
      const allDataPatientHpi = await getPatientHpi()

      const allPatientHpiData = allDataPatientHpi?.Data?.map((item) => {
        return {
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })

      const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
      console.log('result', result)
      setSubjective(result[patientID])

      console.log(result?.[patientID]?.[noteID], 'result?.[patientID]?.[noteID]')
      try {
        const hpiData = result?.[patientID]?.[noteID]?.HPI || {}
        const newFreeTypeText = result?.[patientID]?.[noteID]?.newFreeTypeText || ''
        if (newFreeTypeText) {
          setNewFreeTypeText(newFreeTypeText || '')
        }
        setPatientFinalNoteHpi(hpiData)
      } catch (error) {
        console.error('Error setting patient HPI:', error)
      }

      console.log('patinet subjective', subjective)

      //     console.log("Filtered HPI Data:", result );
      //     console.log(allPatientHpiData, patientID, 'allDataallDataallData')
      //     const filteredByPatient = allPatientHpiData?.filter(item => item?.PatientID ===  patientID);

      //     const latestPatientHPI = filteredByPatient?.sort((a, b) => new Date(b?.CreatedAt) - new Date(a?.CreatedAt))[0];

      //     if(latestPatientHPI?.medicationRemarksForSubjective){
      //         setPatientHpiOtherData((p)=>({
      //             ...p,
      //             medicationRemarksForSubjective:latestPatientHPI?.medicationRemarksForSubjective
      //         }))
      //     }

      //     if(latestPatientHPI?.data){
      //         setPatientHpiOtherData((p)=>({
      //             ...p,
      //             data:latestPatientHPI?.data
      //         }))
      //     }
      //     console.log(latestPatientHPI, 'latestPatientHPI')
      //  setPatientFinalNoteHpi(latestPatientHPI?.HPI)
    } catch (error) {
      console.error(error)
    }
  }

  console.log(subjective[noteID]?.medicationRemarksForSubjective, 'subjective[noteID]?.medicationRemarksForSubjective')

  useEffect(() => {
    fetchPatientFinalNoteDetails()
  }, [hpiAdded, patientID, noteID])

  // Patient Vitals
  const vitalFields = [
    { name: 'BloodPressure', label: 'Blood Pressure', unit: 'mmHg' },
    { name: 'HeartRate', label: 'Heart Rate', unit: 'bpm' },
    { name: 'RespiratoryRate', label: 'Respiratory Rate', unit: 'rpm' },
    { name: 'Temperature', label: 'Temperature', unit: '°F' },
    { name: 'SpO2', label: 'SpO2', unit: '%' },
    { name: 'InhaledO2', label: 'Inhaled O2', unit: '%' },
    { name: 'HeartCirc', label: 'Heart Circ', unit: 'in' },
    { name: 'Height', label: 'Height', unit: 'ft/in' },
    { name: 'Weight', label: 'Weight', unit: 'lbs/oz' },
  ]
  const [vitalsList, setVitalsList] = useState([])
  // const getPatientVitals = async () => {
  //   let allVital = { PatientID: patientID }
  //   allVital = [allVital]
  //   let allData
  //   allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))
  //   allData = JSON.parse(allData.d) || {}

  //   setVitalsList(allData?.Data)
  // }

  const getPatientVitals = async () => {
    setVitalsList(patientDBData?.patientVitals || [])
  }

  useEffect(() => {
    getPatientVitals()
  }, [])

  // PE

  const [count, setCount] = useState(1)
  const [formattedOutput, setFormattedOutput] = useState('')
  const [renderData, setRenderData] = useState(null)
  const [finalHtml, setFinalHtml] = useState('')
  const formatDataForAPI = (data) => {
    let output = ''
    let parsedData = data

    // try {
    //     parsedData = JSON.parse(data);
    // } catch (error) {
    //     console.error("Error parsing data:", error);
    //     return "";
    // }

    // Filter accordions
    const accordions = parsedData.filter((item) => item.type === 'accordion')

    // Format the accordions
    output += 'General Examination\n'
    accordions.forEach((accordion) => {
      if (accordion.isSelected || (accordion.hierarchy && accordion.hierarchy.some((child) => child.isSelected))) {
        output += `  ${accordion.name}\n`

        // Format hierarchy items
        accordion.hierarchy.forEach((headerItem) => {
          if (headerItem.isSelected) {
            output += `    ${headerItem.name.split('-')[0]}\n`

            // Format any children
            if (headerItem.hierarchy && headerItem.hierarchy.length > 0) {
              formatHierarchyItems(headerItem.hierarchy, output, 6)
            }

            // Add input data if present
            if (headerItem.inputData) {
              output += `      ${headerItem.inputData}\n`
            }
          }
        })
      }
    })

    return output
  }

  const formatHierarchyItems = (items, outputString, indentLevel) => {
    if (!items || !items.length) return outputString

    items.forEach((item) => {
      if (item.isSelected) {
        const indent = ' '.repeat(indentLevel)
        const itemName = item.name.split('-')[0]

        if (item.type === 'subHeader') {
          outputString += `${indent}${itemName}: `

          // If this subheader has selected children, add them inline
          const selectedChildren = item.hierarchy?.filter((child) => child.isSelected) || []
          if (selectedChildren.length > 0) {
            const childrenText = selectedChildren.map((child) => child.name.split('-')[0]).join(', ')
            outputString += `${childrenText}`
          } else {
            outputString += '\n'
          }
        } else {
          outputString += `${indent}${itemName}\n`
        }

        // Add input data if present
        if (item.inputData) {
          outputString += `${indent}  Reason: ${item.inputData}\n`
        }

        // Recursively format children with increased indentation
        if (item.hierarchy && item.hierarchy.length > 0 && item.type !== 'subHeader') {
          // Skip children that were already processed inline
          formatHierarchyItems(item.hierarchy, outputString, indentLevel + 2)
        }
      }
    })

    return outputString
  }

  const RenderHierarchy = ({ item }) => {
    if (!item.hierarchy || item.hierarchy.length === 0) {
      return item.isSelected == true ? (
        <>
          <span className="">{item.name.split('-')[0]}</span>
          {item?.inputData && <span className=" ms-2">Reason : {item?.inputData?.split('-')[0]}</span>}
        </>
      ) : null
    }

    return (
      <div
        className={`d-flex ${item.type === 'title' || item.type === 'option' ? 'flex-column' : 'flex-row'}`}
        style={{
          fontWeight: item.type === 'title' || item.type === 'header' ? '700' : '500',
        }}
      >
        <span className="">{item.name.split('-')[0]}</span>
        {item.hierarchy.map((child, index) => (
          <RenderHierarchy key={index} item={child} />
        ))}
      </div>
    )
  }

  const convertToHTML = (item, tabCount = 0, parent) => {
    const indent = ''
    let html = ''

    if (!item.hierarchy || item.hierarchy.length === 0) {
      if (item.isSelected) {
        const parts = item.name.split('-')[0]
        html += `${indent}${parts}, `
        if (item.name.split('-')[0] === 'Unable to test' && item.inputData) {
          html += `  (Reason - ${item.inputData})  <br/>`
        }
      }
      return html
    }

    if (!item.isSelected) return ''

    if (item.type === 'header' || item.type === 'title') {
      html += `<br/><b>${indent}${item.name.split('-')[0]}</b> `
    } else if (item.type === 'subHeader') {
      if (parent?.type === 'header' && parent?.hierarchyType !== 'multi') {
        html += `<br/>`
      }
      html += ` - <i> <u> ${indent}${item.name.split('-')[0]}</u>:&nbsp</i>`
    }

    if (item.type === 'option') {
      html += `<span>${indent}${item.name.split('-')[0]}</span>, `
    }

    if (item.inputData) {
      html += `${indent}<span style="color: gray;">(${item.inputData})</span><br/>`
    }

    item.hierarchy.forEach((child) => {
      html += convertToHTML(child, tabCount + 1, item)
    })

    return html
  }

  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    getDataDiagnosis()
    getRisks()
    getTreatmentPlansData()
    getDataPersonalHistoryInNote()
    // getCallCenterData()
    filterLabsByDiagnosis()
    getMedication()
    getPatientVitals()
    getDataDiagnosis()
    let diagnosis = patientData?.Diagnosis
    let diagnosisList = diagnosis?.split(',')
    setDiagnosis(diagnosisList)

    getCallCenterData(diagnosisList)
    getRisks(diagnosisList)
    GetMasterMedications()
    getHistory()
    getDiagnosisMedicationInRisk()
    fetchPatientFinalNoteDetails()
    setLoading(false)
    setTimeout(() => {}, 3000)
  }, [])

  // const [ddxHtml, setDdxHtml] = useState({})

  // useEffect(() => {
  //   const fetchDdx = async () => {
  //     try {
  //       const response = await axios.get('https://api.jsonbin.io/v3/b/6802025b8a456b79668c0939', {
  //         headers: {
  //           'X-Master-Key': '$2a$10$tHFyzLeQFlPNXCUKVZKoHOYcQ.w6mvUkF6LYxXaanjZFVBcIRPppG',
  //         },
  //       })

  //       const records = response?.data?.record
  //       const patientNotes = records?.patientData?.[patientID]

  //       if (Array.isArray(patientNotes)) {
  //         const findNote = patientNotes.find((item) => item.noteId === setDataId)
  //         if (findNote) {
  //           const treatmentsShellNote = findNote['Treatment Shell']
  //           if (treatmentsShellNote) {
  //             patientDiagnosis.forEach((diagnosis) => {
  //               const ddx = treatmentsShellNote[diagnosis]
  //               if (ddx?.ddx) {
  //                 console.log(`${diagnosis} ke liye aaya ddx`)
  //                 setDdxHtml((prev) => ({
  //                   ...prev,
  //                   [diagnosis]: ddx.ddx,
  //                 }))
  //               } else {
  //                 console.log(`${diagnosis} ke liye nahi aaya ddx`)
  //               }
  //             })
  //           }
  //         } else {
  //           console.log('⚠️ No matching note found for setDataId')
  //         }
  //       } else {
  //         console.log('⚠️ No notes found for this patient')
  //       }
  //     } catch (error) {
  //       console.error('❌ Axios Error:', error)
  //     }
  //   }

  //   fetchDdx()
  // }, [patientID, setDataId, patientDiagnosis])

  const PEData = async () => {
    try {
      let peData = await fetchData()
      console.log(peData, 'peDatapeDatapeData')
      if (peData.length > 0) {
        const html =
          peData.length > 0 &&
          peData
            .filter((item) => item.type === 'accordion' && (item.isSelected || item.hierarchy?.some((child) => child.isSelected)))
            .map((item) => {
              let sectionHtml = `<b style="font-size:14px; text-decoration:underline;">${item.name}</b><br/> `

              item.hierarchy.forEach((bodyItem) => {
                sectionHtml += convertToHTML(bodyItem, 1, item)
              })

              return sectionHtml
            })
            .join('<br/> ')

        const cleanedHtml = html
          .replace(/(<br\/?>\s*){2,}/g, '<br/>')
          .replace(/^(<br\/?>)+/, '')
          .replace(/(<br\/?>)+$/, '')
        console.log(html, cleanedHtml, 'formatted')
        setFinalHtml(cleanedHtml)
      }
    } catch (err) {
      console.log(err, 'pe error')
    }
  }
  console.log(finalHtml, 'final--->')
  // useEffect(() => {
  //     const fetchDataPE = async () => {
  //         try {
  //             await PEData();
  //         } catch (error) {
  //             console.error("Error fetching PEData:", error);
  //         }
  //     };

  //     fetchDataPE();
  // }, []);

  useEffect(() => {
    setLoading(true)
    PEData()
    setLoading(false)
  }, [peAdded])

  // poa
  const [questionValue, setQuestionsValue] = useState([])
  const [newComponents, setNewComponents] = useState([])
  const [dataWithoutValues, setDataWithoutValues] = useState([])
  const [formValue, setFormValues] = useState([])

  let tempData = []
  const filterEmptyAnswers = (data) => {
    return data
      .filter((item) => typeof item === 'object' && !Array.isArray(item))
      .map((item) => {
        return {
          ...item,
          data: Object.fromEntries(Object.entries(item.data).filter(([key, value]) => value !== '')),
        }
      })
  }

  const [orders, setOrders] = useState({})

  const fetchOrders = async () => {
    try {
      let parsedOrders = patientDBData?.ordersData || []
      console.log('patientDBData?.ordersData', patientDBData?.ordersData)
      // let data = await PatientOrdersCRUD('Get', '', patientID)
      // data = JSON.parse(data?.d)
      // const parsedOrders = data?.Data.map((order) => ({
      //   ...order,
      //   medication: JSON.parse(order.medication),
      // }))

      const groupedOrders = {}
      parsedOrders.forEach((order) => {
        const diagnosis = order?.medication?.diagnosis
        if (!groupedOrders[diagnosis]) {
          groupedOrders[diagnosis] = []
        }
        groupedOrders[diagnosis].push({
          date: order?.date,
          imaging: order.medication.imaging,
          lab: order.medication.lab,
          medication: order.medication.medication,
          miscellaneous: order.medication.miscellaneous,
          noteID: order?.medication?.noteID,
        })
      })

      console.log('Grouped Orders:', groupedOrders)
      setOrders(groupedOrders)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  useEffect(() => {
    fetchOrders()
  }, [])

  const getLatestDataForPoa = (allPatientHpiData, patientID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      // /  return patientData && patientData[noteID]
      return patientData
    })
    console.log(filtered, 'filtered getLatestNoteByPatientAndNoteID')

    const latest = filtered.at(-1)
    console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
    return latest || null
  }

  const [freeTypeGlobal, setFreeTypeGlobal] = useState('')

  const getCallCenterDatas = async (diagnosisList) => {
    // let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '');
    // let data = await getCallCenterQuestions();
    // let allData = JSON.parse(data?.d);

    let allData = await getCallCenterQuestions()
    console.log('patinet id allData ', allData)

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestDataForPoa(allPatientHpiData, patientID)

    console.log('call center latest data ---> ', result)

    const convertedData = {}

    const callCenterData = result?.[patientID]?.CCENTER
    const globalFreeType = result?.[patientID]?.globalFreeType
    if (callCenterData) {
      Object.keys(callCenterData).forEach((diagnosis) => {
        convertedData[diagnosis] = callCenterData[diagnosis]?.map((q) => ({
          question: q.label,
          answer: q.answer,
          freeType: q.freeType,
          type: q?.type,
          freewayRemark: q?.freewayRemark,
        }))
      })
    }

    setFreeTypeGlobal(globalFreeType)
    setQuestionsValue(convertedData)
    console.log('Converted Call Center Data', convertedData)

    return convertedData
  }
  useEffect(() => {
    if (Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0) {
      getCallCenterDatas(patientDiagnosis)
    }
  }, [patientDiagnosis])

  const [incidentRemarkGlobal, setIncidentRemarkGlobal] = useState('')
  useEffect(() => {
    const fetchIncidentRemarkGlobal = async () => {
      let incideRemrk = noteStructureRef?.current?.incidentRemark || ''
      console.log(noteStructureRef?.current?.incidentRemark, 'noteStructureRef?.current?.incidentRemark rishi')
      setIncidentRemarkGlobal(incideRemrk)
    }
    fetchIncidentRemarkGlobal()
  }, [addedNewIncident])
  // Get Facility Information
  const [patientFacilityData, setPatientFacilityData] = useState({})
  const getFacilities = async () => {
    // let a = await FacilityCRUD('SELECT', {})
    // let data = JSON.parse(a.d)?.Data
    let data = await getFacilityData()
    try {
      if (patientData?.FacilityName) {
        let facility = data.find((item) => item.Name === patientData?.FacilityName)
        if (facility) {
          setPatientFacilityData(facility)
        } else {
          console.log('Facility not found')
        }
      } else {
        console.log('patientData?.FacilityName not found')
      }
    } catch (e) {}
  }

  const [peGlobalRemark, setPeGlobalRemark] = useState('')
  const [customPEHtml, setCustomPEHtml] = useState('')
  const fetchData = async () => {
    let lastGeneralExamination = []
    let lastLastDiagnosisExamination = []
    // let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID, noteID)
    // const parsedData = JSON.parse(response.d).Data || []

    const parsedData = patientDBData?.PEPatientData || {}
    console.log(patientDBData?.PEPatientData, 'pe data in ls')
    const findLastDiagnosisExaminationData = parsedData.filter((item) => item.Type === 'DiagnosisExaminationData' && item?.NoteID === noteID?.toString()) || []
    const findLastGeneralDiagnosisExamination = parsedData.filter((item) => item.Type === 'GeneralExaminationData' && item?.NoteID === noteID?.toString()) || []
    const PhysicalExaminationEditedHtml = parsedData.filter((item) => item.Type === 'PhysicalExaminationEditedHtml' && item?.NoteID === noteID?.toString()) || {}
    const globalRemarks = parsedData.filter((item) => item.Type === 'PhysicalExaminationGlobalRemark' && item?.NoteID === noteID?.toString())
    const lastGlobalRemark = globalRemarks[globalRemarks.length - 1] || null
    let lastCustomPhysicalExaminationEditedHtml = PhysicalExaminationEditedHtml[PhysicalExaminationEditedHtml.length - 1]
    lastCustomPhysicalExaminationEditedHtml = lastCustomPhysicalExaminationEditedHtml ? JSON.parse(lastCustomPhysicalExaminationEditedHtml?.JsonData) : {}
    console.log(lastCustomPhysicalExaminationEditedHtml, 'lastCustomPhysicalExaminationEditedHtml')
    setCustomPEHtml(lastCustomPhysicalExaminationEditedHtml?.html || '')

    const jsonRemarkGlobalRemark = lastGlobalRemark ? JSON.parse(lastGlobalRemark.JsonData) : null
    setPeGlobalRemark(jsonRemarkGlobalRemark?.globalRemarkText || '')

    if (findLastGeneralDiagnosisExamination.length > 0) {
      lastGeneralExamination = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData) || []
    }
    if (findLastDiagnosisExaminationData.length > 0) {
      lastLastDiagnosisExamination = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData) || []
    }
    if (lastGeneralExamination.length > 0 || lastLastDiagnosisExamination.length > 0) {
      console.log([...lastGeneralExamination, ...lastLastDiagnosisExamination], 'pedata')
      // setPeData([...lastGeneralExamination, ...lastLastDiagnosisExamination])
    }

    return [...lastGeneralExamination, ...lastLastDiagnosisExamination]
  }

  // useEffect(() => {
  //     fetchData()
  // }, [peAdded])

  const [reviewOfSystemOffline, setReviewOfSystemOffline] = useState('')
  useEffect(() => {
    const fetchReviewOfSystemOffline = async () => {
      // let reviewOfSystem = patientDBData?.currentNote?.data?.reviewOfSystem || ''
      let reviewOfSystem = noteStructureRef?.current?.reviewOfSystem || ''
      setReviewOfSystemOffline(reviewOfSystem)
    }
    fetchReviewOfSystemOffline()
  }, [addedNewIncident, rosAdded])

  const [allIncidents, setAllIncidents] = useState([])
  const [patientIncidentOffline, setPatientIncidentOffline] = useState({})

  useEffect(() => {
    const fetchIncidentData = async () => {
      const incidentObj = noteStructureRef?.current?.incident
      const incideRemrk = noteStructureRef?.current?.incidentRemark || ''
      // if (!patientID) {
      //   return
      // }
      // if (patientDBData && Object.keys(patientDBData).length === 0) return

      // const offlineIncidentData = patientDBData?.currentNote?.data.incident
      setPatientIncidentOffline(incidentObj)
      // let incideRemrk = patientDBData?.currentNote?.data?.incidentRemark || ''
      if (incidentObj) {
        const allKeys = Object.keys(incidentObj)

        const structuredIncidents = allKeys
          .filter((key) => Array.isArray(incidentObj[key]))
          .map((key) => {
            const [diagnosis, date] = key.split('_')
            return {
              diagnosis,
              date,
              incidents: incidentObj[key],
            }
          })

        setAllIncidents(structuredIncidents)
      }
    }
    fetchIncidentData()
  }, [patientID, addedNewIncident, noteStructureRef?.current])

  useEffect(() => {
    getFacilities()
  }, [patientData])
  const [textareaInputValue, setTextareaInputValue] = useState('')
  const rteRef = useRef(null)
  const handleExport = () => {
    if (rteRef.current) {
      rteRef.current.exportToPdf()
    }
  }

  console.log(noteStructureRef?.current?.freeTypesEverything?.patientDetails, noteStructureRef, 'hospitalRecords check')

  useEffect(() => {
    let lastHospitalRecord = hospitalRecords?.find((item) => item.Id === noteStructureRef.current?.metadata?.historyId)?.History ? `${hospitalRecords?.find((item) => item.Id === noteStructureRef.current?.metadata?.historyId)?.History}` : ''
    let lastHistoryId = noteStructureRef?.current?.metadata?.historyId
    let highlightsArr = noteStructureRef.current?.highlightDetails?.[lastHistoryId] || []
    lastHospitalRecord = lastHospitalRecord.trim().replace(/\n/g, '<br/>')

    // apply highlights
    highlightsArr.forEach((word) => {
      if (word) {
        const regex = new RegExp(`(${word})`, 'gi')
        lastHospitalRecord = lastHospitalRecord.replace(regex, `<span style="font-weight:bold;">$1</span>`)
      }
    })

    console.log(lastHospitalRecord, 'lastHospitalRecord', highlightsArr, lastHistoryId)

    const keyOfallHistoriesList = {
      'Past Medical History': 'PMHx',
      'Past Surgical History': 'PSHx',
      'Family History': 'FHx',
      'Social History': 'SHx',
    }
    // noteStructureRef.current.freeTypesEverything.hospitalRecordsFreetype
    console.log(allHistoriesList, 'allHistoriesList')
    const formattedHistories =
      Array.isArray(allHistoriesList) && allHistoriesList.length > 0
        ? `
      <table style="width: 100%; font-size: 11pt; border-collapse: collapse; margin-top: 10pt;">
        ${allHistoriesList
          .map(
            (history) => `
          <tr style="vertical-align: top;">
            <td style="width: 30%; border: 0; font-weight: bold; font-size: 13pt; padding: 6px 0; vertical-align: top;">
              ${keyOfallHistoriesList[history?.heading] || ''}
            </td>
            <td style="width: 70%; white-space: pre-line; border: 0; padding: 6px 4px;">
            ${noteStructureRef.current?.freeTypesEverything?.historyFreetype?.[history?.key]?.trim() || history?.entry?.trim()}
            </td>
          </tr>
        `,
          )
          .join('')}
      </table>
    `
        : ''

    //         const formattedAllergies =
    //             allergies?.length > 0
    //                 ? `
    //   <table style="width: 100%; font-size: 11pt; border-collapse: collapse; margin-bottom: 10px;">
    //     ${allergies
    //                     .filter(item =>
    //                         noteStructureRef?.current?.metadata?.allergiesIds?.includes(item.id)
    //                     )
    //                     .map(
    //                         (item, idx) => `
    //             <tr style="vertical-align: top;">

    //               ${idx === 0
    //                                 ? `<td rowspan="${allergies.length}" style="width: 30%;border:0; font-weight: bold; font-size: 13pt; padding: 6px 0; vertical-align: top;">Allergies</td>`
    //                                 : ''
    //                             }
    //               <td style="width: 70%; padding: 0px 0px;border:0;">
    //                 <span>Allergen: ${item.data?.allergen || ''}</span>
    //                 <span>Severity: ${item.data?.severity || ''}</span>
    //                 <span>Reaction: ${item.data?.reaction || ''}</span>
    //               </td>
    //             </tr>
    //           `
    //                     )
    //                     .join('')
    //                 }
    //   </table>
    //   `
    //                 : '<div>No allergies</div>';

    const filteredAllergies = allergies?.filter((item) => noteStructureRef?.current?.metadata?.allergiesIds?.includes(item.id)) || []
    const freeTypeAllergy = noteStructureRef?.current?.freeTypesEverything?.allergiesFreetype

    const formattedAllergies = `
<table style="width: 100%; font-size: 11pt; border-collapse: collapse; margin-bottom: 10px;">
  <tr style="vertical-align: top;">
    <td style="width: 30%; border: 0; font-weight: bold; font-size: 13pt; padding: 6px 0; vertical-align: top;">
      Allergies
    </td>

    ${
      freeTypeAllergy
        ? `
          <td style="width: 70%; padding: 6px 0; vertical-align: top; border: 0;">
            ${freeTypeAllergy}
          </td>
        `
        : fetchAllergy?.length > 0
        ? `
          <td style="width: 70%; padding: 6px 0; vertical-align: top; border: 0;">
            <div>
              ${fetchAllergy
                .map(
                  (item) => `
                    <div style="margin-bottom: 4px; display: flex; gap: 12px;">
                      <div><span style="font-weight:600;">Allergen:</span> ${item.data?.allergen || ''}</div>
                      <div><span style="font-weight:600;">Severity:</span> ${item.data?.severity || ''}</div>
                      <div><span style="font-weight:600;">Reaction:</span> ${item.data?.reaction || ''}</div>
                    </div>
                  `,
                )
                .join('')}
            </div>
          </td>
        `
        : `
          <td style="width: 70%;padding: 6px 0; vertical-align: top; border: 0;">
            Patient Has No Allergies
          </td>
        `
    }
  </tr>
</table>
`
    const linkedVitalId = noteStructureRef?.current?.metadata?.vitalId
    const lastVital = (linkedVitalId && vitalsList?.find((v) => String(v.ID) === String(linkedVitalId))) || vitalsList?.[vitalsList.length - 1]
    console.log(lastVital, 'last vitals')

    let formattedVitals = ''
    if (lastVital) {
      formattedVitals = `

    <div>
    <span>${lastVital?.Date?.split(' ')[0]?.replace(/\./g, '/')}</span>
    <div>
    ${vitalFields
      .map((field) => {
        return lastVital[field.name] ? `<strong>${field.label}</strong>: ${lastVital[field.name]} ${field.unit || ''}` : ''
      })
      .filter(Boolean)
      .join(', ')}
    </div>
</div>
    `
    }

    const reviewValue = (reviewOfSystemOffline && reviewOfSystemOffline?.editROS) || ''
    console.log(typeof reviewValue, 'reviewValue')
    const reviewSystemHtml = reviewValue
      ? `<span style="white-space: pre-wrap;">${reviewValue}
                </span>`
      : ''

    // const medEntry = medication[medication.length - 1];
    const medEntry = medication.find((item) => item.id === noteStructureRef.current?.metadata?.medId)
    console.log(medEntry, 'medEntry stepped')
    // const medicationNotes =
    //   medEntry?.data
    //     ?.map((med) => {
    //       return `${med.name} ${med.dosage} ${med.route} ${med.frequency} ${med?.standingTemplateName || ''}`
    //     })
    //     .join('') || ''
    const medicationNotes =
      medEntry?.data
        ?.map((med) => {
          const medText = `${med.name} ${med.dosage} ${med.route} ${med.frequency} ${med?.standingTemplateName || ''}`
          return med?.inMaster ? `<strong>${medText}</strong>` : medText
        })
        .join('') || ''

    // const hpiNotes = patientDiagnosis.map((diagnosisItem) => {
    //     const hpiData = patientFinalNoteHpi?.[diagnosisItem] || [];
    //     const formattedHpi = hpiData.map((hpi) => `<div><span>${hpi.label}: ${hpi.answer}</span> </div>`).join('');
    //     return `
    //     <div style="margin-bottom: 10px;">
    //         <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${diagnosisItem?.toUpperCase()}</p>
    //         <div>
    //     <div style="">${formattedHpi}</div>
    //         </div>
    //       </div>
    //   `;
    // }).join('') || '';
    // const hpiNotes =
    //   patientDiagnosis
    //     .map((diagnosisItem) => {
    //       const hpiData = patientFinalNoteHpi?.[diagnosisItem] || []

    //       const formattedHpi = hpiData.length > 0 ? hpiData.map((hpi) => `<div><span>${hpi.label}: ${hpi.answer}</span></div>`).join('') : ''

    //       return formattedHpi
    //         ? `
    //                 <div style="margin-bottom: 10px;">

    //                     <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${diagnosisItem?.toUpperCase()}</p>
    //                     <div>${formattedHpi}</div>
    //                 </div>
    //               `
    //         : ''
    //     })
    //     .join('') || ''

    console.log(patientDiagnosis, 'patientDiagnosis patientDiagnosis')

    const hpiNotes =
      (patientDiagnosis || [])
        .map((diagnosisItem) => {
          const hpiData = patientFinalNoteHpi?.[diagnosisItem] || []

          console.log(hpiData, 'hpiData in ls view')

          // Pick freetype remark only from the first entry
          let freeTypeRemark = ''

          if (hpiData.length > 0 && hpiData[0]?.freewayRemark) {
            freeTypeRemark = `
    <div style="padding-left: 10px; color: #444;  ">
        ${hpiData[0]?.freewayRemark}
    </div>
  `
          }

          const formattedHpi =
            hpiData.length > 0
              ? hpiData
                  .map((hpi) => {
                    const label = hpi?.label || ''
                    const answer = Array.isArray(hpi?.answer) ? hpi.answer.join(', ') : hpi?.answer.split('|||').join(', ') || ''
                    const parentQuestion = hpi?.parentQuestion?.split('-')[1] || ''
                    const freetypeBottomText = hpi?.freeType

                    return `<div style="padding-left: 10px; margin-bottom: 10px;">
              <span>
                    ${parentQuestion !== '' ? `[${parentQuestion}]` : ''} ${label ? `<span style="font-weight:700">${label}</span> : ${answer}` : `${answer}`}
              </span>
              ${freetypeBottomText ? `<div style=" ">Freetype : ${freetypeBottomText}</div>` : ''}  
            </div>`
                  })
                  .join('')
              : ''

          return formattedHpi
            ? `
          <div style="margin-bottom: 10px;">
            <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">
              ${diagnosisItem?.toUpperCase()}
            </p>
            ${freeTypeRemark}
            <div>${formattedHpi}</div>
          </div>
        `
            : ''
        })
        .join('') || ''

    // let incidentHtmlParentContent = ''

    // console.log(patientIncidentOffline, 'patientIncidentOffline')
    // patientDiagnosis.forEach((diagnosis) => {
    //   if (patientIncidentOffline) {
    //     const allKeys = Object.keys(patientIncidentOffline)
    //     // const filteredKeys = allKeys.filter((key) => key?.toLowerCase()?.startsWith(diagnosis))
    //     const filteredKeys = allKeys.filter((key) => key.toLowerCase().startsWith(diagnosis?.toLowerCase()))

    //     const allIncidentsWithDates = filteredKeys.map((key) => {
    //       const date = key.split(`${diagnosis}_`)[1]
    //       return {
    //         date: date,
    //         incidents: patientIncidentOffline[key],
    //       }
    //     })

    //     console.log(allIncidentsWithDates, 'allIncidentsWithDates')

    //     if (allIncidentsWithDates.length > 0) {
    //       const htmlForDiagnosis = allIncidentsWithDates
    //         .map((incident) => {
    //           const itemsHtml =
    //             incident?.incidents && incident?.incidents.length > 0
    //               ? incident?.incidents
    //                   .filter((item) => item.answer)
    //                   .map(
    //                     (item, idx) =>
    //                       `<div>
    //                                     <span class="p-0 m-0">${idx + 1}. ${item.label}</span><br/>
    //                                     <span class="p-0 m-0">Answer: ${item.answer}</span>
    //                                  </div>`,
    //                   )
    //                   .join('')
    //               : ''

    //           return `
    //                     <div>
    //                         <span style="margin:0;padding:0pt;padding:6pt 0pt;">
    //                             <strong>${diagnosis}</strong> - ${new Date(incident?.date).toLocaleDateString('en-US')}
    //                         </span>
    //                                             ${incident?.incidents.length > 0 && incident?.incidents[0]?.freeRemark ? `<p className='py-2' style={{whiteSpace:"pre-line"}}>${incident?.incidents[0]?.freeRemark ? incident?.incidents[0]?.freeRemark : ''}</p> ` : ''}
    //                         ${itemsHtml}
    //                     </div>
    //                 `
    //         })
    //         .join('')

    //       incidentHtmlParentContent += htmlForDiagnosis
    //     }
    //   }
    // })

    let incidentHtmlParentContent = ''

    if (patientIncidentOffline) {
      const allKeys = Object.keys(patientIncidentOffline)

      // Loop through all keys inside patientIncidentOffline
      const allIncidents = allKeys.map((key) => {
        const lastUnderscoreIndex = key.lastIndexOf('_')

        const diagnosis = key.substring(0, lastUnderscoreIndex) // before _
        const date = key.substring(lastUnderscoreIndex + 1) // after _

        return {
          diagnosis,
          date,
          incidents: patientIncidentOffline[key],
        }
      })

      allIncidents.forEach((incident) => {
        const itemsHtml =
          incident?.incidents && incident?.incidents.length > 0
            ? incident.incidents
                .filter((item) => item.answer)
                .map(
                  (item, idx) =>
                    `<div>
                   <span class="p-0 m-0">${idx + 1}. ${item.label}</span><br/>
                   <span class="p-0 m-0">Answer: ${item.answer}</span><br/>
${item?.freeType ? `<span class="p-0 m-0">FreeType: ${item.freeType}</span>` : ''}
                 </div>`,
                )
                .join('')
            : ''

        const freeRemark = incident?.incidents?.length > 0 && incident?.incidents[0]?.freeRemark ? `<p class='py-2' style='white-space:pre-line;'>${incident.incidents[0].freeRemark}</p>` : ''

        incidentHtmlParentContent += `
      <div>
        <span style="margin:0;padding:6pt 0pt;">
          <strong>${incident.diagnosis}</strong> - 
          ${new Date(incident.date).toLocaleDateString('en-US')}
        </span>
        ${freeRemark}
        ${itemsHtml}
      </div>
    `
      })
    }

    const imagingNote =
      imaging
        ?.filter((imgEntry) => !noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))
        ?.map((obj) => {
          const date = new Date(obj.date).toLocaleDateString('en-US')
          const name = obj.data?.name || ''
          const impression = obj.data?.impression || ''
          return `<div style="margin-bottom: 8px;padding: ;">
            <span>${date} - ${name}</span><br/>
            <span>Impressions:</span><br/>${impression}
          </div>`
        })
        .join('') || ''

    let allLabsParentHtml = ''

    console.log(allLabs, 'allLabs stepped')

    if (allLabs.length > 0) {
      allLabsParentHtml = allLabs
        .filter((item) => (noteStructureRef.current?.metadata?.labId || []).includes(item.id))
        .map((lab) => {
          console.log('date====>', lab)
          const date = new Date(lab.date.split('.').join('/')).toLocaleDateString('en-US')

          const labEntries = lab.data
            .map((lab) => {
              const value = lab.value ? parseFloat(lab.value) : null
              const rangeParts = lab.range ? lab.range.split('-').map((part) => parseFloat(part.trim())) : []
              console.log(rangeParts, 'rangeParts')
              const isValueInRange = value !== null && rangeParts.length === 2 && value >= rangeParts[0] && value <= rangeParts[1]
              return `
                <div style="display:flex; ${isValueInRange ? '' : 'font-weight:bold;'}">
    <p style="margin: 0;">
      ${lab.name} ${lab.value} ${lab.unit}
    </p>
  </div>
              `
            })
            .join('')

          return `
               <div style="margin-bottom: 8px;">
                <p style="margin: 0;">Date: ${date}</p>
                ${labEntries}
               </div>
            `
        })
        .join('')
    }

    const reviewOfSystem = noteStructureRef?.current?.reviewOfSystem || ''

    const treatmentShellHTML = (patientDiagnosis || [])

      ?.filter(Boolean)
      ?.map((diagnosis, i) => {
        const riskfactorFreetype = noteStructureRef?.current?.freeTypesEverything?.riskfactors?.[diagnosis] || ''
        const riskFactor =
          selectedRisks && selectedRisks[diagnosis]
            ? selectedRisks[diagnosis]
                .split(',')
                .map((risk) => risk.trim())
                .filter(Boolean)
                .join(', ')
            : ''

        console.log(riskFactor, 'riskFactorriskFactor', selectedRisks, 'selectedRisks')
        const allQuestions = currentNoteData?.historyOfDiagnosis?.[diagnosis]

        const historyOfDiagnosis =
          allQuestions && allQuestions.length > 0
            ? `
<div style="margin-bottom:10pt;">
  <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">
    History of Diagnosis
  </p>
  ${allQuestions
    .map((q) => {
      const answer = q?.answer ? q.answer?.split('|||') : 'No Answer'
      const freeType = q?.freeType ? ` "${q.freeType}"` : ''
      return `<p style="margin:0;line-height:20px;font-size:10pt;">
                ${q?.label}: <strong>${answer}</strong>${freeType}
              </p>`
    })
    .join('')}
</div>
`
            : ''

        //     console.log(riskfactorFreetype,diagnosis,'riskfactorFreetype for diagnosis')

        // const riskFactorHtmlContent =
        //   riskFactor || riskfactorFreetype &&

        //   `
        //         <div style="margin-bottom:5pt;margin-top:5pt">
        //         <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Risk Factor'}</p>
        //         ${riskfactorFreetype ? `<div style="white-space: pre-wrap; margin-bottom: 5px;">${riskfactorFreetype}</div>` : ''}
        //         ${riskFactor ? `<div style="white-space: pre-wrap;">${riskFactor}</div>` : ''}
        //       </div>
        const riskFactorHtmlContent =
          riskfactorFreetype || riskFactor
            ? `
      <div style="margin-bottom:5pt;margin-top:5pt">
        <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">
          Risk Factor
        </p>

        ${
          riskfactorFreetype
            ? `<div style=";">
                ${riskfactorFreetype}
              </div>`
            : ''
        }

        ${
          riskFactor
            ? `<div style="">
                ${riskFactor}
              </div>`
            : ''
        }
      </div>
    `
            : ''

        ;`

        //         const differentialDiagnosisHTML = ddxHtml[diagnosis]
        //           ? `
        // <div style="margin-bottom:10pt;">
        //         <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Differential Diagnosis'}</p>
        //             <p style="margin-top:0;">          ${ddxHtml[diagnosis].replace(/\n/g, '<br />')}</p>
        // </div>
        //     `
        //           : ''

        //         const morseCodeHtml =
        //             diagnosis === 'Falls' &&
        //                 noteStructureRef?.current?.MorseScore
        //                 ? (() => {
        //                     const { date, score } = noteStructureRef.current.MorseScore[diagnosis];
        //                     const totalScore = score && score[score.length - 1]; // Last index is the total score

        //                     return `
        // <div style="margin-bottom:10pt;">
        //         <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${"Morse Score"}</p>
        //             <p style="margin-top:0;"><span>Score :</span> ${totalScore} <span style=";">Date :</span> ${formatDate(date)}</p>
        // </div>
        // `;
        //                 })()
        //                 : '';

        const freetypeMorseCode = noteStructureRef?.current?.freeTypesEverything?.MorseScore?.[diagnosis]

        console.log(noteStructureRef?.current?.MorseScore?.[diagnosis], 'noteStructureRef?.current?.MorseScore?.[diagnosis]')

        const morseCodeHtml =
          diagnosis === 'Falls' && noteStructureRef?.current?.MorseScore?.[diagnosis]
            ? (() => {
                const entry = noteStructureRef.current.MorseScore[diagnosis]
                const { date, score } = entry || {}
                const totalScore = Array.isArray(score) ? score[score.length - 1] : 'N/A'

                return freetypeMorseCode
                  ? freetypeMorseCode
                  : `
        <div style="margin-bottom:10pt;">
            <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Morse Score'}</p>
            <p style="margin-top:0;">
              <span>Score :</span> ${totalScore} 
              <span style="">Date :</span> ${date ? formatDate(date) : 'Unknown'}
            </p>
        </div>
        `
              })()
            : ''

        const ddxValues = (noteStructureRef?.current && noteStructureRef?.current?.patientDifferentialDiagnosis && noteStructureRef?.current?.patientDifferentialDiagnosis[diagnosis] && noteStructureRef?.current?.patientDifferentialDiagnosis[diagnosis]) || ''
        let ddxHtmlsTreatMents = ''
        if (ddxValues && ddxValues.length > 0) {
          const ddxFormatted = ddxValues.replace(/\n/g, '<br />')

          ddxHtmlsTreatMents = ddxFormatted
            ? `
      <div style="margin-bottom:5pt;margin-top:5pt">
        <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">Differential Diagnosis</p>
        <p style="margin-top:0;">${ddxFormatted}</p>
      </div>
    `
            : ''
        }

        const alertValue = (noteStructureRef?.current && noteStructureRef?.current?.alertData && noteStructureRef?.current?.alertData[diagnosis] && noteStructureRef?.current?.alertData[diagnosis]) || ''
        let alertHtml = ''
        if (alertValue && alertValue.length > 0) {
          console.log(alertValue, typeof alertValue, 'alertValue')
          alertHtml = alertValue
            ? `
                <div style="margin-bottom:5pt;margin-top:5pt">
                <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Alerts'}</p>
                    <div style="white-space: pre-wrap;margin-top:0;">${alertValue}</div>
        </div>`
            : ''
        }
        const bimsScoreData = noteStructureRef?.current?.BIMSScore?.[diagnosis]

        const bimsScoreHtml =
          diagnosis === 'Cognitive Communication Deficit' && bimsScoreData
            ? (() => {
                const { date, score } = bimsScoreData
                console.log(date, score, 'date, score')

                return `
                <div style="margin-bottom:5pt;margin-top:5pt">
                <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'BIMS Score'}</p>
                                    <p style="margin-top:0;">Score :${score || 0} <span style="margin-left:20px;">Date :</span> ${formatDate(date) || ''}</p>
              </div>
                                `
              })()
            : ''

        const lastLab = allLabs[allLabs.length - 1]
        const lastLabArrOfLabs = lastLab?.data || []
        const allMatchingLab =
          lastLabArrOfLabs &&
          lastLabArrOfLabs.filter((item) => {
            const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
            return diagnosisLab.some((diagn) => diagn.includes(diagnosis))
          })
        const matchingLabHtml = allMatchingLab.length
          ? `
                <div style="margin-bottom:5pt;margin-top:5pt">
      <p style="font-size:14px; font-weight:bold;">Lab Details</p>

      <div>
        ${allMatchingLab
          .map((item) => {
            return `
            <div style="display: flex; gap: 10px; font-size: 13px;">
              <p style="line-height:2;">${new Date(allLabs[allLabs.length - 1]?.date).toLocaleDateString('en-US')} ${item.name} ${item.value || '-'} ${item.unit || '-'} ${item?.comment || ''}</p>
            </div>
          `
          })
          .join('')}
      </div>
    </div>
  `
          : ''

        let matchingImagingDiagnosis = null

        const lastImaging = imaging?.length > 0 ? imaging[imaging.length - 1] : null

        if (imagingTypeList.length > 0 && lastImaging?.data && MasterDiagnosisData) {
          const lastImagingImpression = lastImaging.data.impression.toLowerCase()
          const lastImagingName = lastImaging.data.name.toLowerCase()

          const matchingImagingMaster = imagingTypeList.find((item) => item.Name.toLowerCase() === lastImagingName)

          if (matchingImagingMaster) {
            const matchedKeywords = matchingImagingMaster.Keywords.filter((keywordDetail) => {
              const keywords = keywordDetail.keyword
                .split(',')
                .map((k) => k.trim().toLowerCase())
                .filter(Boolean)
              return keywords.some((k) => lastImagingImpression.includes(k))
            })

            for (const remark of matchedKeywords) {
              const matchedDiagnosis = MasterDiagnosisData.find((d) => d.id === Number(remark.diagnosis))
              if (matchedDiagnosis && diagnosis.trim() === matchedDiagnosis.Name.trim()) {
                matchingImagingDiagnosis = {
                  ...matchedDiagnosis,
                  ...remark,
                  ...lastImaging,
                }
                console.log(diagnosis, matchingImagingDiagnosis, 'matchingImagingDiagnosis for diagnosis')
                break
              }
            }
          }
        }

        const imagingHTML = matchingImagingDiagnosis?.data
          ? `
            <div style="padding: ;">
        <h7>Imagings</h7>
    <p class="text-warning">
        ${new Date(matchingImagingDiagnosis.date).toLocaleDateString('en-US')} : 
        ${matchingImagingDiagnosis.data.name}
    </p>
    <p class="text-warning">${matchingImagingDiagnosis.data.impression}</p>
    <p class="text-warning">${matchingImagingDiagnosis.data.comment}</p>
    </div>
    `
          : ''

        let freeType = ''
        let poa = ''
        let assessment = ''
        let newAssessment = ''
        let assessmentSuggestions = ''
        // assessmentSuggestions = data?.assessment[diagnosis]?.
        freeType = (noteStructureRef?.current?.assessment && noteStructureRef?.current?.assessment[diagnosis]?.FreeType) || ''
        if (patientTreatments && patientTreatments.length > 0) {
          let treatmentDetails = patientTreatments[noteID || 0]
          console.log('treatments', treatmentDetails, noteID)
          if (!treatmentDetails) {
            treatmentDetails = patientTreatments[0]
          }
          const { data } = treatmentDetails
          if (!data?.assessment) {
            // noteStructureRef.current = {
            //   ...noteStructureRef.current,
            //   assessment: {
            //     ...noteStructureRef.current.assessment,
            //     [diagnosis]: {
            //       MobilityAssessment: {},
            //       POA: '',
            //       MorseScore: {},
            //       LabImaging: '',
            //       FreeType: '',
            //     },
            //   },
            // }
          } else if (data?.assessment && !data?.assessment[diagnosis]) {
            // noteStructureRef.current = {
            //   ...noteStructureRef.current,
            //   assessment: {
            //     ...noteStructureRef.current.assessment,
            //     [diagnosis]: {
            //       MobilityAssessment: {},
            //       POA: '',
            //       MorseScore: {},
            //       LabImaging: '',
            //       FreeType: '',
            //     },
            //   },
            // }
            console.log('data=====[][][][][==========>')
          } else if (data?.assessment && data?.assessment[diagnosis]) {
            console.log('type of dataq', typeof data.assessment[diagnosis])
            if (typeof data.assessment[diagnosis] === 'string') {
              // noteStructureRef.current = {
              //   ...noteStructureRef.current,
              //   assessment: {
              //     ...noteStructureRef.current.assessment,
              //     [diagnosis]: {
              //       MobilityAssessment: {},
              //       POA: '',
              //       MorseScore: {},
              //       LabImaging: '',
              //       FreeType: '',
              //     },
              //   },
              // }
            }
          }
          let existingAssessment = `${data?.assessment && data?.assessment[diagnosis]?.LabImaging} ` || ''
          // const existingAssessment = (data?.assessment && data?.assessment[diagnosis]) || "";
          if (existingAssessment.trim() === 'undefined' || existingAssessment === 'null') {
            console.log('existingAssessment==========>', existingAssessment)
            existingAssessment = ''
          }
          // let freeTypeData = (data?.assessment && data?.assessment[diagnosis]?.FreeType) || ''
          // if (diagnosis !== 'Falls') {
          //     existingAssessment = (data?.assessment && data?.assessment[diagnosis]) || "";
          // } else {
          //     existingAssessment = (data?.assessment && data?.assessment[diagnosis]?.LabImaging) || "";
          // }
          // setFreeType(freeTypeData);
          // freeType = freeTypeData
          newAssessment = existingAssessment || ''
        } else {
          // noteStructureRef.current = {
          //   ...noteStructureRef.current,
          //   assessment: {
          //     ...noteStructureRef.current.assessment,
          //     [diagnosis]: {
          //       MobilityAssessment: {},
          //       POA: '',
          //       MorseScore: {},
          //       LabImaging: '',
          //       FreeType: '',
          //     },
          //   },
          // }
        }
        let allImagingRemarks = null
        let lastLabsRemarks = []
        let standingMedicationTemplate = ''
        if (imagingTypeList.length > 0 && lastImaging?.data) {
          const lastImagingImpression = lastImaging.data.impression.toLowerCase()
          const lastImagingPatientSelectedImaging = lastImaging.data.name.toLowerCase()
          const findMatchingImagingMaster = imagingTypeList.find((item) => item.Name.toLowerCase() === lastImagingPatientSelectedImaging)
          if (findMatchingImagingMaster) {
            let matchingDiagnosisImaging = []
            for (let keywordDetail of findMatchingImagingMaster.Keywords) {
              const keywordsArray = keywordDetail.keyword
                .split(',')
                .map((keyword) => keyword.trim().toLowerCase())
                .filter((keyword) => keyword !== '')
              if (keywordsArray.some((item) => lastImagingImpression.includes(item?.toLowerCase()))) {
                matchingDiagnosisImaging.push(keywordDetail)
              }
            }
            for (const remarkD of matchingDiagnosisImaging) {
              for (const masterD of MasterDiagnosisData) {
                if (masterD.id === Number(remarkD.diagnosis)) {
                  if (diagnosis.trim() === masterD.Name.trim()) {
                    allImagingRemarks = [
                      {
                        ...masterD,
                        ...remarkD,
                        ...lastImaging,
                      },
                    ]
                  }
                }
              }
            }
          }
        }
        if (allLabs.length > 0) {
          const lastLab = allLabs[allLabs.length - 1]
          const lastLabArrOfLabs = lastLab?.data || []
          let allMatchingLab = lastLabArrOfLabs.filter((item) => {
            const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
            return diagnosisLab.some((diagn) => diagn.includes(diagnosis))
          })
          lastLabsRemarks = allMatchingLab.map((item) => item.remark).filter((item) => item !== '')
        }
        if (lastLabsRemarks.length > 0) {
          const lastLabsRemarksText = lastLabsRemarks.join('\n')
          if (!newAssessment.includes(lastLabsRemarksText)) {
            if (newAssessment !== '') {
              // newAssessment += '\n';
            }
            newAssessment += lastLabsRemarksText
          }
        }
        if (allImagingRemarks) {
          if (!newAssessment.includes(allImagingRemarks[allImagingRemarks.length - 1]?.remarks)) {
            if (newAssessment !== '') {
              // newAssessment += '\n';
            }
            newAssessment += allImagingRemarks[allImagingRemarks.length - 1]?.remarks //tunr this off letter
          }
          console.log('Assessment imagging', allImagingRemarks)
          // newAssessment += allImagingRemarks?.remarks; // turn this on
        }
        if (newAssessment.trim() !== '' && newAssessment.trim() !== 'undefined' && newAssessment !== 'null') {
          console.log('diagnosis name ', diagnosis, newAssessment)
          // setAssessment(newAssessment);
          assessment = newAssessment
          const currentAssessment = noteStructureRef.current.assessment || {}
          const existingDiagnosisData = currentAssessment[diagnosis] || {
            MobilityAssessment: {},
            POA: '',
            MorseScore: {},
            LabImaging: '',
            FreeType: '',
          }
        }

        // const morseCodeHtmlInAssessment =
        //     diagnosis === 'Falls' &&
        //         noteStructureRef?.current?.MorseScore
        //         ? (() => {
        //             const { date, score } = noteStructureRef.current.MorseScore[diagnosis];
        //             const totalScore = score && score[score.length - 1]; // Last index is the total score

        //             return `<div>Morse Score: ${totalScore} Date: ${new Date(date).toLocaleDateString('en-US')}</div>`;
        //         })()
        //         : '';

        const morseCodeHtmlInAssessment =
          diagnosis === 'Falls' && noteStructureRef?.current?.MorseScore?.[diagnosis]
            ? (() => {
                const entry = noteStructureRef.current.MorseScore[diagnosis]
                const { date, score } = entry || {}
                const totalScore = Array.isArray(score) ? score[score.length - 1] : 'N/A'
                const formattedDate = date ? new Date(date).toLocaleDateString('en-US') : 'Unknown'

                return `<div>Morse Score: ${totalScore} Date: ${formattedDate}</div>`
              })()
            : ''

        console.log(noteStructureRef?.current, 'noteStructureRef?.current?.MorseScore')

        //mobilityHtmlInAssessment in falls
        const questionFields = [
          { key: 'rollLeftAndRight', label: 'Roll left and right' },
          { key: 'sitToLying', label: 'Sit to lying' },
          { key: 'lyingToSittingOnSideOfBed', label: 'Lying to sitting on side of bed' },
          { key: 'sitToStand', label: 'Sit to stand' },
          { key: 'chairToBedTransfer', label: 'Chair to bed transfer' },
          { key: 'toiletTransfer', label: 'Toilet transfer' },
          { key: 'walk10Feet', label: 'Walk 10 feet' },
          { key: 'ambulatoryAids', label: 'Ambulatory aids' },
        ]

        const commonOptions = [
          { label: 'Independent', value: 'independent' },
          { label: 'Set up or cleanup assistance', value: 'setup_or_cleanup_assistance' },
          { label: 'Supervision or touching assistant', value: 'supervision_or_touching_assistant' },
          { label: 'Partial moderate assistant', value: 'partial_moderate_assistant' },
          { label: 'Substantial maximal assistant', value: 'substantial_maximal_assistant' },
          { label: 'Dependent', value: 'dependent' },
          { label: 'Patient refused', value: 'patient_refused' },
        ]

        const ambulatoryOptions = [
          { label: 'None', value: 'none' },
          { label: 'Wheelchair', value: 'wheelchair' },
          { label: 'Cane', value: 'cane' },
          { label: 'Walker', value: 'walker' },
        ]

        const mobilityValuesInAssessment = noteStructureRef?.current?.MobilityAssessment?.assessment
        assessmentSuggestions = noteStructureRef?.current?.assessment?.[diagnosis]?.assessmentSuggestions

        console.log(noteStructureRef.current)

        // const mobilityHtmlInAssessment =
        //   diagnosis === 'Falls' && mobilityValuesInAssessment
        //     ? (() => {
        //       return `<div>
        //   ${questionFields
        //           .map((field) => {
        //             const selected = mobilityValuesInAssessment[field.key]
        //             if (selected && selected.length > 0) {
        //               const values = selected.map((item) => item.label).join(', ')
        //               return `<div class="" style="">${field.label}: ${values}</div>`
        //             }
        //             return ''
        //           })
        //           .join('')}
        // </div>`
        //     })()
        //     : ''

        const mobilityFreetype = noteStructureRef?.current?.freeTypesEverything?.MobilityAssessment?.[diagnosis] || ''

        const date = noteStructureRef?.current?.MobilityAssessment?.date
        const formattedDate = date ? new Date(date).toLocaleDateString('en-US') : 'Unknown'

        const mobilityHtmlInAssessment =
          diagnosis === 'Falls' && mobilityValuesInAssessment
            ? (() => {
                return ` 
                <div>Date: ${formattedDate}</div>
                <div>
                  ${questionFields
                    .map((field) => {
                      const selected = mobilityValuesInAssessment[field.key]
                      if (selected && selected.length > 0) {
                        const values = selected.map((item) => (item?.label ? item.label : JSON.stringify(item))).join(', ')
                        return `<div class="" style="">${field.label}: ${values}</div>`
                      }
                      return ''
                    })
                    .join('')}
            </div>`
              })()
            : ''

        let incidentHtmlContent = ``

        if (patientIncidentOffline) {
          const allKeys = Object.keys(patientIncidentOffline)
          const filteredKeys = allKeys.filter((key) => key.startsWith(diagnosis))

          const allIncidentsWithDates = filteredKeys.map((key) => {
            const date = key.split(`${diagnosis}_`)[1]
            return {
              date: date,
              incidents: patientIncidentOffline[key],
            }
          })

          if (allIncidentsWithDates.length > 0) {
            incidentHtmlContent = allIncidentsWithDates
              .map((incident) => {
                const itemsHtml =
                  incident?.incidents && incident?.incidents.length > 0
                    ? incident?.incidents
                        .filter((item) => item.answer)
                        .map(
                          (item, idx) =>
                            `<div>
                                              <p class="p-0 m-0">${idx + 1}. ${item.label}</p>
                                              <p class="p-0 m-0">Answer: ${item.answer}</p>
${item?.freeType ? `<span class="p-0 m-0">FreeType: ${item.freeType}</span>` : ''}

                                            </div>`,
                        )
                        .join('')
                    : ''

                console.log(itemsHtml, 'itemsHtml')
                return `
                                    <div>
                                      <p style="margin:0;padding:0pt;padding:6pt 0pt">${new Date(incident?.date).toLocaleDateString('en-US')}</p>
                                                ${incident?.incidents[0]?.freeRemark ? `<p className='' style={{whiteSpace:"pre-line"}}>${incident?.incidents[0]?.freeRemark ? incident?.incidents[0]?.freeRemark : ''}</p> ` : ''}

                                      ${itemsHtml}
                                    </div>
                                `
              })
              .join('')
          }
        }

        console.log('assessment for', diagnosis, poa.trim(), assessment, morseCodeHtmlInAssessment, mobilityHtmlInAssessment, bimsScoreData)

        const assessmentHtmlContent =
          poa.trim() || assessment.trim() || freeType.trim() || morseCodeHtmlInAssessment.trim() || mobilityHtmlInAssessment.trim() || bimsScoreData || assessmentSuggestions
            ? `
                        <div style="margin-bottom: 10pt;">
                <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Assessment'}</p>
                <div>
            <div style="">
            ${poa ? `<div>${poa}</div>` : ''}
            ${mobilityHtmlInAssessment}
            ${morseCodeHtmlInAssessment}
            ${assessmentSuggestions ? `<div style="white-space: pre-line;">${assessmentSuggestions}</div>` : ''}
            ${freeType ? `<div>${freeType}</div>` : ''}
            ${assessment ? `<div>${assessment}</div>` : ''}
  ${bimsScoreData ? `<div>Bims Score: ${bimsScoreData?.score} Date: ${new Date(bimsScoreData?.date).toLocaleDateString('en-US')}</div>` : ''}
           </div>
                </div>
              </div>
  `
            : ''

        console.log(incidentHtmlContent, 'incidentHtmlContent')

        let allData = []
        let planFormat = ''
        let lab = ''
        let misc = ''
        let planHtmlContent = null
        let selfCareHtmlContent = null
        let freetype = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.freeType

        console.log(freetype, noteStructureRef?.current?.plans, 'freetype for plans')

        if (patientTreatments && patientTreatments.length > 0) {
          let treatmentDetails = patientTreatments[noteID || 0]

          if (!treatmentDetails) {
            treatmentDetails = patientTreatments[0]
          }

          const { data } = treatmentDetails

          console.log(data, 'data for')
          // noteStructureRef.current = data   /// if something is not work plan then uncomment it, may be work

          let miscData = data && data.plans && data?.plans[diagnosis]?.labRemark + data?.plans[diagnosis]?.misc
          // console.log("misc data==========>", data?.plans[diagnosis]?.labRemark, data?.plans[diagnosis]?.misc)

          // lab = data?.plans && data?.plans[diagnosis] && data?.plans[diagnosis]?.labRemark
          // misc = data?.plans && data?.plans[diagnosis] && data?.plans[diagnosis]?.freeType
          // let planSuggestions = data?.plans && data?.plans[diagnosis] && data?.plans[diagnosis]?.planSuggestion
          // let freetype = data?.plans && data?.plans[diagnosis] && data?.plans[diagnosis]?.freeType
          // let labRemark = data?.plans && data?.plans[diagnosis] && data?.plans[diagnosis]?.labRemark
          // let ordersList = orders[diagnosis] || []
          // console.log(orders, 'orders in view note', diagnosis)
          // allData = data?.plans && data?.plans[diagnosis] && data?.plans[diagnosis]?.medsDetails

          lab = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.labRemark
          misc = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.freeType
          let planSuggestions = noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosis]?.planSuggestions || (noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.planSuggestion)
          // let freetype = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.freeType
          let labRemark = noteStructureRef.current?.freeTypesEverything?.assessments?.[diagnosis]?.LabImaging || noteStructureRef?.current?.plans?.[diagnosis]?.labRemark
          let ordersList = orders[diagnosis] || []
          console.log(orders, 'orders in view note', diagnosis)
          allData = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.medsDetails
          const formattedMedicationDetailsInFormattedRed =
            allData &&
            allData.length > 0 &&
            allData
              ?.map((item) => {
                // return `${item?.name} - <span>${item?.dosage}</span> - <span class="med-frequency" >${item?.frequency}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span></span>`;
                // return ` <span style="">${item?.editedMed}</span> <br/> <span class="standing-template" style="">${item?.extraStandings}</span> <br/> <span class="standing-template" style="">${item?.sideEffect}</span> <br/> <span class="standing-template" style="">${item?.mechanismOfAction}</span> <br/> <span class="standing-template" style="">${item?.alerts}</span> <br/> <span class="standing-template" style="">${item?.therapeuticLevels?.min} - ${item?.therapeuticLevels?.max}</span>`;
                return `                         <span style="">${item?.editedMed}</span>  
`
              })
              .join('<br/>')
          //         let orderHtmlPlan = ''

          //       { noteStructureRef?.current?.freeTypesEverything?.OrderFreeType  ?
          //         noteStructureRef?.current?.freeTypesEverything?.OrderFreeType   :
          //          if (orders && orders[diagnosis]?.length > 0) {
          //           console.log('orders in view note mapping', diagnosis)
          //           orderHtmlPlan += `<label style="margin:0;margin-top:5pt;padding:0;line-height: 0;" class="form-label">New Orders</label><div>`

          //           orders[diagnosis].forEach((currentOrder) => {
          //             console.log(orders[diagnosis], 'orders[diagnosis]', orders, noteID, currentOrder?.noteID, currentOrder)
          //             if (currentOrder?.noteID !== noteID) {
          //               return
          //             }
          //             orderHtmlPlan += `<div class="">`

          //             // Imaging – inline with spacing between each item
          //             if (currentOrder?.imaging?.imagingTypes?.length > 0) {
          //               orderHtmlPlan += `
          //     <div style="display:flex;gap:4pt;margin:0;padding:0;">
          //     <span style="margin:0;margin-top:0pt;padding:0;">Imaging : </span>
          //       ${currentOrder.imaging.imagingTypes
          //                   .map((imagingItem) => {
          //                     const type = typeof imagingItem?.type === 'object' ? JSON.stringify(imagingItem?.type) : imagingItem?.type || ''
          //                     return `<span style="margin:0;padding:0;">${type},</span>`
          //                   })
          //                   .join('')}
          //   </div>
          // `
          //             }

          //             // Labs
          //             if (currentOrder?.lab?.labs?.length > 0) {
          //               orderHtmlPlan += `
          //     <div style="display:flex;gap:4pt;margin:0;padding:0;">
          //     <span style="margin:0;margin-top:0pt;padding:0;">Labs: </span>
          //       ${currentOrder.lab.labs
          //                   .map((labItem) => {
          //                     const lab = typeof labItem?.lab === 'object' ? JSON.stringify(labItem?.lab) : labItem?.lab || ''
          //                     const reason = typeof labItem?.reason === 'object' ? JSON.stringify(labItem?.reason) : labItem?.reason || ''
          //                     return `<span style="margin:0;padding:0;">${lab}${reason ? ` - Reason for ${lab}` : ''},</span>`
          //                   })
          //                   .join('')}

          //   </div>
          // `
          //             }

          //             // Medications
          //             if (currentOrder?.medication?.medication?.length > 0) {
          //               orderHtmlPlan += `
          //     <div style="display:flex;gap:4pt;margin:0;padding:0;">
          //     <span style="margin:0;padding:0;">Medications: </span>
          //       ${currentOrder.medication.medication
          //                   .map((medItem) => {
          //                     return `<span style="margin:0;padding:0;">${medItem?.name} ${medItem?.dosage} ${medItem?.route}${medItem?.frequency ? ` ${medItem?.frequency}` : ''}${medItem?.reason ? ` - ${medItem?.reason}` : ''},</span>`
          //                   })
          //                   .join('')}
          //   </div>
          // `
          //             }

          //             // // Miscellaneous
          //             orderHtmlPlan += `
          //               <div style="margin:0;padding:0;">

          //                 <span style="margin:0;padding:0;">
          //                   ${(currentOrder?.miscellaneous?.miscellaneous || []).map((misc) => `<span style="margin:0;padding:0;">Miscellaneous: ${misc}</span>`).join('')}
          //                 </span>
          //               </div>
          //             `

          //             orderHtmlPlan += `</div>` // close order block
          //           })

          //           orderHtmlPlan += `</div>` // close all orders block
          //         }}

          let orderHtmlPlan = ''

          // 1️⃣ If FreeType exists → use it directly
          if (orders && orders[diagnosis]?.length > 0) {
            if (noteStructureRef?.current?.freeTypesEverything?.OrderFreeType[diagnosis]) {
              {
                console.log('noteStructureRef?.current?.freeTypesEverything?.OrderFreeType', noteStructureRef?.current?.freeTypesEverything?.OrderFreeType[diagnosis])
              }
              orderHtmlPlan = `
  <div  style="
      white-space: pre-line;
      font-family: inherit;
      text-align: left;
    ">
    ${noteStructureRef.current.freeTypesEverything.OrderFreeType?.[diagnosis]}
  </div>
`
            } else {
              console.log('orders in view note mapping', diagnosis)

              orderHtmlPlan += `
    <label class="form-label" style="margin:0;margin-top:5pt;padding:0;">
      New Orders
    </label>
    <div>
  `

              orders[diagnosis].forEach((currentOrder) => {
                if (currentOrder?.noteID !== noteID) return

                orderHtmlPlan += `<div>`

                // Imaging
                if (currentOrder?.imaging?.imagingTypes?.length > 0) {
                  orderHtmlPlan += `
        <div style="display:flex;gap:4pt;">
          <span>Imaging:</span>
          ${currentOrder.imaging.imagingTypes
            .map((item) => {
              const type = typeof item?.type === 'object' ? JSON.stringify(item.type) : item?.type ?? ''
              return `<span>${type},</span>`
            })
            .join('')}
        </div>
      `
                }

                // Labs
                if (currentOrder?.lab?.labs?.length > 0) {
                  orderHtmlPlan += `
        <div style="display:flex;gap:4pt;">
          <span>Labs:</span>
          ${currentOrder.lab.labs
            .map((lab) => {
              const labName = typeof lab?.lab === 'object' ? JSON.stringify(lab.lab) : lab?.lab ?? ''
              return `<span>${labName}${lab?.reason ? ` - ${lab.reason}` : ''},</span>`
            })
            .join('')}
        </div>
      `
                }

                // Medications
                if (currentOrder?.medication?.medication?.length > 0) {
                  orderHtmlPlan += `
        <div style="display:flex;gap:4pt;">
          <span>Medications:</span>
          ${currentOrder.medication.medication
            .map(
              (med) => `
              <span>
                ${med?.name ?? ''} ${med?.dosage ?? ''} ${med?.route ?? ''}
                ${med?.frequency ? ` ${med.frequency}` : ''}
                ${med?.reason ? ` - ${med.reason}` : ''},
              </span>
            `,
            )
            .join('')}
        </div>
      `
                }

                // Miscellaneous
                if (currentOrder?.miscellaneous?.miscellaneous?.length > 0) {
                  orderHtmlPlan += `
        <div>
          ${currentOrder.miscellaneous.miscellaneous.map((misc) => `<div>Miscellaneous: ${misc}</div>`).join('')}
        </div>
      `
                }

                orderHtmlPlan += `</div>` // close single order
              })

              orderHtmlPlan += `</div>` // close all orders
            }
          }

          console.log(orderHtmlPlan, 'orderHtmlPlan', diagnosis)

          // ${planFormat ? `<div style="">${planFormat}</div>` : ""}

          const planFormat = formattedMedicationDetailsInFormattedRed || ''

          console.log(noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosis]?.MedsDetails, 'noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosis]?.MedsDetails')
          console.log(orderHtmlPlan, planSuggestions, allTreamentStatements[diagnosis], freetype, labRemark, diagnosis, '=====freetype', diagnosis)
          planHtmlContent =
            planFormat || orderHtmlPlan || planSuggestions || allTreamentStatements[diagnosis] || freetype || labRemark
              ? `
                        <div style="margin-bottom: 10px;">
                <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Plan'}</p>
                ${freetype ? `<div style="white-space: pre-line;margin-top:0;">${freetype}</div>` : ''}
                ${planSuggestions ? `<div style="white-space: pre-line;margin-top:0;">${planSuggestions}</div>` : ''}
                ${labRemark ? `<div style="white-space: pre-line;margin-top:0;">${labRemark}</div>` : ''}
                ${orderHtmlPlan ? ` <div>${orderHtmlPlan}</div>` : ''}
                ${planFormat || noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosis]?.MedsDetails ? `<div>${noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosis]?.MedsDetails || planFormat}</div>` : ''}
                ${
                  allTreamentStatements[diagnosis] || noteStructureRef?.current?.freeTypesEverything?.plans?.allTreatments?.[diagnosis]
                    ? `<div style="white-space: pre-line;margin-top:0;">${noteStructureRef?.current?.freeTypesEverything?.plans?.allTreatments?.[diagnosis] || allTreamentStatements[diagnosis]}</div>`
                    : ''
                }
              </div>
  `
              : ''
        } else {
        }

        const diagnosisData = noteStructureRef?.current?.selfCareAssessment?.[diagnosis] || {}
        const formattedSelfCareAssessment = Object.entries(diagnosisData)
          .map(([domain, value]) => {
            if (Array.isArray(value) && value.length > 0) {
              return value
                .map(
                  (item) => `
          <div style="margin:0;line-height:16px;">
            <p style="text-transform: capitalize;">${domain}: ${item}</p>
          </div>
        `,
                )
                .join('')
            }

            if (typeof value === 'string' && value.trim()) {
              return `
        <div style="margin:0;line-height:16px;">
          <p style="text-transform: capitalize;">${domain}: ${value}</p>
        </div>
      `
            }
            return ''
          })
          .filter(Boolean)
          .join('')
        const selfCareAssessmentFormat = formattedSelfCareAssessment || ''
        selfCareHtmlContent = selfCareAssessmentFormat
          ? `
                 <div style="margin:2px 0;">
                    ${selfCareAssessmentFormat}
                  </div>                
              `
          : ''
        // poa

        const formatted = questionValue?.[diagnosis] || []

        const poaHtmlContent =
          formatted && formatted.length > 0
            ? `
                <div  >
                <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;padding-bottom:0pt:white-space:normal;">${'POA'}</p>

                <div style="white-space:normal;">
              
    ${formatted
      .map(
        (item) => `
                <div>${item?.freewayRemark && item?.freewayRemark} </div>
          <p style="margin:0"> <span style="font-weight:bold;text-decoration : ${item?.type === 'Header' ? 'underline' : 'none'}; font-size: ${item?.type === 'Header' ? '15.5px;' : '14px;'}">
    ${item.type === 'Header' ? item.question : item.type === 'subHeader' ? `${item.question} :` : `${item.question} -`}
  </span><span style="font-size: 13px; color:white;">${item.answer?.replace(/color\s*:\s*[^;"]+;?/gi, '')}</span></p>
          ${item.freeType && `<div >  <span style="font-weight:bold;font-size: 14px;">FreeType </span> - <span style="font-size: 13px;">${item?.freeType?.replace(/color\s*:\s*[^;"]+;?/gi, '')} <span>  </div>`} 

        `,
      )
      .join('')}
</div>
 
</div>
                `
            : ''

        return `
                <table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;white-space: normal">
    <tr style="vertical-align: top;">
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0; padding: 6px 0px; border: 0; line-height: normal;"><div style="margin-bottom:5pt;margin-top:5pt"><p>${diagnosis?.toUpperCase()}</p></div</td>
      <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
                ${poaHtmlContent}

                ${historyOfDiagnosis ? `${historyOfDiagnosis}` : ''}

        ${
          incidentHtmlContent
            ? `
                <div style="margin-bottom:5pt;margin-top:5pt">
            <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">Incident</p>
            ${incidentHtmlContent}
            </div>`
            : ''
        }
            
            ${riskFactorHtmlContent}
            
            ${ddxHtmlsTreatMents}

        ${alertHtml}

        ${morseCodeHtml}
        
        ${bimsScoreHtml}        

        ${assessmentHtmlContent}

         ${selfCareHtmlContent}

        ${planHtmlContent}
     
      </td>
    </tr>
  </table>
</>
      <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>
        </div>
        </div>


      </div>
      
    `
      })
      .join('')

    // const [addendum, setAddendum] = useState([])
    //      const fetchAddendumData = async () => {
    //             try {
    //                 let data = await SaveExtra('Get_By_Type', 'Addendum', '', '');

    //                 data = JSON.parse(data?.d)?.Data || [];

    //                 data = data.map(item => JSON.parse(item?.JsonData));
    //                 console.log("Addendum data fetched", data)
    //                 data = data.reverse(); // latest first

    //                 const currentNoteID = noteID.toString();
    //                 const noteIDNum = parseInt(noteID, 10);
    //                 console.log("Current Note ID:", currentNoteID, "Note ID Number:", noteIDNum);
    //                 const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null;
    //                 console.log("Current Note ID:", currentNoteID, "Previous Note ID:", previousNoteID);

    //                 const findPatientNoteData = (data, patientID, noteID) => {
    //                     for (let i = 0; i < data.length; i++) {
    //                         const item = data[i];
    //                         console.log("Checking item:", item);

    //                         if (item[patientID]) {

    //                             if (item[patientID][currentNoteID]) {
    //                                 console.log(`Found exact match: patient ${patientID}, noteID ${currentNoteID}`);
    //                                 return item[patientID][currentNoteID];
    //                             }

    //                             if (previousNoteID && item[patientID][previousNoteID]) {
    //                                 console.log(`Found previous note: patient ${patientID}, noteID ${previousNoteID}`);
    //                                 return item[patientID][previousNoteID];
    //                             }
    //                         }
    //                     }
    //                     return null;
    //                 };

    //                 const result = findPatientNoteData(data, patientID, noteID);
    //                 console.log("Addendum result:", result);
    //                 if (result) {
    //                     setAddendum(result);
    //                 } else {
    //                     const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID;
    //                     console.warn(`Patient ${patientID} with note ${searchNotes} not found`);
    //                     setAddendum(null);
    //                 }
    //             } catch (error) {
    //                 console.error('Failed to fetch addendum data:', error);
    //                 setAddendum(null);
    //             }
    //         };

    //         useEffect(() => {
    //             fetchAddendumData();
    //         }, []);

    // Function to format date from DD-MM-YYYY to MM/DD/YYYY
    const formatDateNew = (dateString) => {
      if (!dateString) return ''
      const parts = dateString.split('-')
      if (parts.length !== 3) return dateString
      const [month, day, year] = parts
      const date = new Date(`${year}-${month}-${day}`)
      return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date)
    }

    // Function to generate HTML-formatted text for Syncfusion Rich Text Editor
    const generateAddendumHTMLText = (addendumData) => {
      if (!addendumData || !addendumData.orders || addendumData.orders.length === 0) {
        return null
      }
      const formattedDate = formatDateNew(addendumData?.syncDate)

      const labelCellStyle = 'width:30%; border:0; font-weight:bold; font-size:13pt; padding:16px 0; vertical-align:top;'
      const valueCellStyle = 'width:70%; border:0; font-size:11pt; padding:16px 0; vertical-align:top;'
      const formatList = (items) => items.filter(Boolean).join(', ')
      const ordersHtml = addendumData.orders
        .map((currentOrder, idx) => {
          const medications = currentOrder.medication?.medication?.map((medItem) => {
            const details = [medItem.name, medItem.dosage, medItem.route, medItem.frequency].filter(Boolean).join(' ')
            return medItem.reason ? `${details} - ${medItem.reason}` : details
          }) || []
          const labs = currentOrder.lab?.labs?.map((labItem) => {
            const lab = labItem.lab || ''
            return labItem.reason ? `${lab} - Reason for ${lab}: ${labItem.reason}` : lab
          }) || []
          const imaging = currentOrder.imaging?.imagingTypes?.map((img) => (typeof img?.type === 'object' ? JSON.stringify(img?.type) : img?.type || '')) || []
          const miscellaneous = currentOrder.miscellaneous?.miscellaneous?.map((miscItem) => (typeof miscItem === 'object' ? miscItem?.type || '' : miscItem)) || []

          return `
<div style="${idx === addendumData.orders.length - 1 ? '' : 'margin-bottom:8px; padding-bottom:8px; border-bottom:0.5px solid #d8dbe0;'}">
${currentOrder.diagnosis ? `<div><strong>Diagnosis:</strong> ${currentOrder.diagnosis}</div>` : ''}
${medications.length ? `<div><strong>Medications:</strong> ${formatList(medications)}</div>` : ''}
${labs.length ? `<div><strong>Labs:</strong> ${formatList(labs)}</div>` : ''}
${imaging.length ? `<div><strong>Imaging:</strong> ${formatList(imaging)}</div>` : ''}
${miscellaneous.length ? `<div><strong>Miscellaneous:</strong> ${formatList(miscellaneous)}</div>` : ''}
</div>`
        })
        .join('')
      const poacHtml = addendumData?.poac?.map((item) => item?.poacData?.content).filter(Boolean).join('<br/><br/>') || ''
      const addendumContent = `
<div><strong>Date:</strong> ${formattedDate}</div>
<div style="margin-top:10px;"><strong>Orders</strong></div>
<div style="margin-top:4px;">${ordersHtml}</div>
${poacHtml ? `
<div style="margin-top:16px;"><strong>POAC</strong></div>
<div style="margin-top:4px; white-space:pre-wrap;">${poacHtml}</div>
` : ''}
`

      return `
<div style="width:100%; font-size:11pt; margin-bottom:10px;">
  <div style="margin-bottom: 8px; font-weight: bold; font-size: 13pt;">ADDENDUM</div>
  <div style="line-height: 1.6; white-space: normal;">${addendumContent}</div>
</div>`
    }

    console.log(incidentRemarkGlobal, incidentHtmlParentContent, 'incidentRemarkGlobal || incidentHtmlParentContent')

    const noteHTML = `
          <div style="white-space: normal">

          ${
            noteStructureRef?.current?.freeTypesEverything?.patientDetails
              ? noteStructureRef?.current?.freeTypesEverything?.patientDetails
              : `
                      <table style="width: 100%; border: none; border-collapse: collapse;">
  <tr style="border: none;">
    <td style="border: none; font-weight: 700; font-size: 13pt;">
      Bay Area Neurology LLC<br />
      <span style="font-weight: 400;">
        Correspondence address
      </span><br />
       <span style="font-weight: 400;">
        3225 S MACDILL AVE STE 129-300, TAMPA, FL, 33629-8171
        </span>
    </td>
    <td style="border: none; text-align: right; font-weight: 700; font-size: 13pt;">
      Neurology Consult Note
    </td>
  </tr>
</table>
     <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>

           <br/>

<table style="width: 100%; border: none; border-collapse: collapse;">
  <tr style="border: none;">
    <td style="border: none; font-size: 13pt;">
      <span style="border: none; font-weight: 700; font-size: 13pt;">${patientData?.FirstName || ''} ${patientData?.MiddleName || ''} ${patientData?.LastName || ''}</span></br>
            <span style=margin:0;padding:0;line-height:normal;font-size:11pt;>Patient Type: ${patientExtraData && patientExtraData.patientTerm ? patientExtraData.patientTerm : patientData?.term ? patientData?.patientTerm : ''}</span>
    </td>
  </tr>
</table>
<table style="width: 100%; border: none; border-collapse: collapse;">
  <tr style="border: none;">
    <td style="border: none;">
${patientData?.DOB ? `DOB: <b>${patientData.DOB}</b><br />` : ''}
${(() => {
  const signedNote = patientTreatments.find((note) => note?.status === 'Signed' && note?.data?.noteID === noteID)
  return signedNote
    ? `<br />Electronically signed by:
    <b>${patientExtraData?.providerAssigned || patientData?.providerAssigned || ''}</b> ( ${signedNote?.data?.signatureInfo?.signedDate} , ${signedNote?.data?.signatureInfo?.signedTimeUs} )`
    : ''
})()}   <br />
Visit on ${patientExtraData?.scheduleStartTime ? patientExtraData?.scheduleStartTime?.split(' ')[0] || '' : patientData?.scheduleStartTime?.split(' ')[0] || ''}
    </td>
  </tr>
</table>
 <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>
           <br/>
            <div>
            <p style="margin:0;font-weight: 700;line-height:normal;font-size: 13pt;">Locations</p>
            <div>
            <span style=margin:0;padding:0;line-height:normal;font-size:11pt;>${patientFacilityData?.Name || ''}(${patientFacilityData?.Type}) - ${patientData?.Room || ''}</span>
            </div>
            </div>

           <br/>
            `
          }

            ${
              ((!noteStructureRef?.current?.freeTypesEverything?.hospitalRecordsFreetype && lastHospitalRecord) || '')?.trim()
                ? `<table style="width: 100%;border-collapse: collapse; font-size: 11pt; margin-bottom: 10px;">
    <tr style="vertical-align: top;">
      <td style="width: 30%; font-weight: bold; font-size: 13pt;border: 0; padding: 6px 0;">HOSPITAL RECORDS</td>
      <td style="width: 70%; padding: 6px 0px;border: 0; white-space: pre-line">${lastHospitalRecord}</td>
    </tr>
  </table>
             `
                : ''
            }

${
  noteStructureRef?.current?.freeTypesEverything?.hospitalRecordsFreetype
    ? `<table style="width: 100%;border-collapse: collapse; font-size: 11pt; margin-bottom: 10px;">
    <tr style="vertical-align: top;">
      <td style="width: 30%; font-weight: bold; font-size: 13pt;border: 0; padding: 6px 0;">HOSPITAL RECORDS</td>
      <td style="width: 70%; padding: 6px 0px;border: 0; white-space: pre-line">${noteStructureRef?.current?.freeTypesEverything?.hospitalRecordsFreetype && noteStructureRef?.current?.freeTypesEverything?.hospitalRecordsFreetype?.trim()}</td>
    </tr>
  </table>`
    : ''
}
      
            
             
           
     ${!showDataIfNoteIsFollowUp && formattedHistories ? `<div>${formattedHistories}</div> ` : ''}
      <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>
            
       <div>${formattedAllergies}</div>
        <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>

        ${
          formattedVitals || noteStructureRef?.current?.freeTypesEverything?.vitalsFreetype
            ? `<table style="width: 100%; font-size: 11pt; margin-bottom: 10px; border-collapse: collapse;border:0;">
    <tr style="vertical-align: top;">
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding-top: 10pt;padding: 0pt; line-height: normal;border:0;">Vitals</td>
      <td style="width: 70%; padding: 6px 0px; line-height: normal;border:0; white-space: normal">
        ${noteStructureRef?.current?.freeTypesEverything?.vitalsFreetype ? noteStructureRef?.current?.freeTypesEverything?.vitalsFreetype : formattedVitals}
      </td>
    </tr>
  </table>
   <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>
  
            `
            : ''
        }
         

      ${
        medicationNotes || noteStructureRef?.current?.freeTypesEverything?.medHtml
          ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
    <tr style="">
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Medication</td>
      <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
        ${noteStructureRef?.current?.freeTypesEverything?.medHtml ? noteStructureRef?.current?.freeTypesEverything?.medHtml : medicationNotes || ''}
      </td>
    </tr>
  </table>
   <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>`
          : ''
      }
       
              ${
                allLabsParentHtml || noteStructureRef?.current?.freeTypesEverything?.labsFreetype
                  ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
    <tr style="vertical-align: top;">
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Labs</td>
      <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
        ${noteStructureRef?.current?.freeTypesEverything?.labsFreetype ? noteStructureRef?.current?.freeTypesEverything?.labsFreetype : allLabsParentHtml || ''}
      </td>
    </tr>
  </table>
   <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>
          `
                  : ''
              }
               

           ${
             imagingNote || noteStructureRef?.current?.freeTypesEverything?.imagingHtml
               ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
    <tr style="vertical-align: top;">
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Imaging</td>
      <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
        ${noteStructureRef?.current?.freeTypesEverything?.imagingHtml ? noteStructureRef?.current?.freeTypesEverything?.imagingHtml : imagingNote || ''}
      </td>
    </tr>
  </table>
   <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>`
               : ''
           }
           
  ${
    incidentRemarkGlobal || incidentHtmlParentContent
      ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
    <tr>
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0; vertical-align: top;">
        <div>Incidents</div>
      </td>
      <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;white-space: normal">
      ${incidentRemarkGlobal ? `<span style="margin: 0 0 6pt 0;">${incidentRemarkGlobal}</span>` : ''}
        ${incidentHtmlParentContent || ''}
      </td>
    </tr>
  </table>
   <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>`
      : ''
  }
   
  ${
    newFreeTypeText || hpiNotes || subjective?.[noteID]?.medicationRemarksForSubjective || subjective?.[noteID]?.data
      ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
    <tr style="">
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0; vertical-align: top;"><div>${hpiHeading ? hpiHeading : patientData?.Status === 'Follow Up' ? 'Subjective' : 'HPI'}</div></td>
      <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
        <div style="white-space: normal">
        ${newFreeTypeText ? `<div style="white-space: pre-line;margin-top:0;margin-bottom:2pt">${newFreeTypeText}</div>` : ''}
        ${subjective?.[noteID]?.medicationRemarksForSubjective ? `<div style="white-space: pre-line;margin-top:0;margin-bottom:2pt;">${subjective[noteID]?.medicationRemarksForSubjective}</div>` : ''}
                ${subjective[noteID]?.data ? `<div style="white-space: pre-line;margin-top:0;margin-bottom:2pt">${subjective[noteID]?.data}</div>` : ''}
            </div>
    </tr>
  </table>
         
            <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>`
      : ''
  }
            ${
              reviewSystemHtml
                ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
    <tr style="vertical-align: top;">
      <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Review Of System</td>
      <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
        ${reviewSystemHtml || ''}
      </td>
    </tr>
  </table>
           <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>`
                : ''
            }


${
  noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText || noteStructureRef?.current?.freeTypesEverything?.peChanges?.html || peGlobalRemark || customPEHtml || finalHtml
    ? `
<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
  <tr style="vertical-align: top;">
    <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">
      Physical Examination
    </td>
    <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">

      ${noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText ? `<p>${noteStructureRef.current.freeTypesEverything.peChanges.globalRemarkText}rishi</p>` : peGlobalRemark ? `<p>${peGlobalRemark}</p>` : ''}

      ${noteStructureRef?.current?.freeTypesEverything?.peChanges?.html ? noteStructureRef.current.freeTypesEverything.peChanges.html : customPEHtml ? customPEHtml : finalHtml || ''}

    </td>
  </tr>
</table>

<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>
`
    : ''
}


            
           <br/>

           ${
             treatmentShellHTML
               ? `<p style="margin:0;font-weight: 700;line-height:normal;font-size: 13pt;padding-bottom:10pt;">ASSESSMENT/PLAN</p>
            <div style="padding: " >
            <div style="margin:0 line-height:normal; padding-bottom:10pt;">${freeTypeGlobal || ''} </div>
             <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
  <tr style="border:none; height:0; line-height:0;">
    <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
  </tr>
</table>
      ${treatmentShellHTML}
    </div>
           <br/>`
               : ''
           }
            
           ${
             generateAddendumHTMLText(addendumData)
               ? `
    <div style="padding: 0;">
      ${generateAddendumHTMLText(addendumData)}
    </div>
  `
               : ''
           }
           <br/>

          </div>


        `.trim()

    setTextareaInputValue(noteHTML)
  }, [
    patientFacilityData,
    patientDiagnosis,
    questionValue,
    finalHtml,
    hpiAdded,
    patientFinalNoteHpi,
    peAdded,
    addedNewIncident,
    incidentRemarkGlobal,
    rosAdded,
    reviewOfSystemOffline,
    patientIncidentOffline,
    changesInTreatmentShell,
    noteStructureRef?.current?.plans,
    noteStructureRef?.current?.patientDifferentialDiagnosis,
  ])

  console.log(hpiAdded, 'hpiAdded in note view')

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  return (
    <>
      {noteShow && (
        <div className="w-100  text-center rounded-pill py-2 " style={{}} textBgColor="primary">
          Note
        </div>
      )}
      {/* 
            {showTreatmentAsAccordion && <span className='d-flex align-items-end justify-content-end'>
                <CButton variant='outline' style={{ width: "50px!important" }} className='' onClick={() => toPDF({ page: { margin: "Margin.SMALL" } })}>Download Pdf</CButton>
            </span>} */}

      {loading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div ref={targetRef} className="custom-scrollbar">
          <div className="control-pane">
            <div className="control-section" id="rte">
              <div className="rte-control-section " style={{ background: '#191919', pointerEvents: 'none' }}>
                <RichTextEditorComponent
                  id="defaultRTE"
                  allowPdfExport={true}
                  exportPdf={{
                    serviceUrl: 'https://services.syncfusion.com/js/production/api/RichTextEditor/ExportToPdf',
                    fileName: 'RichTextEditor.pdf',
                  }}
                  exportWord={{
                    serviceUrl: 'https://services.syncfusion.com/js/production/api/RichTextEditor/ExportToDocx',
                    fileName: 'RichTextEditor.docx',
                  }}
                  value={textareaInputValue}
                  toolbarSettings={{
                    items: [
                      'Undo',
                      'Redo',
                      '|',
                      'ImportWord',
                      'ExportWord',
                      'ExportPdf',
                      '|',
                      'Bold',
                      'Italic',
                      'Underline',
                      'StrikeThrough',
                      'InlineCode',
                      'SuperScript',
                      'SubScript',
                      '|',
                      'FontName',
                      'FontSize',
                      'FontColor',
                      'BackgroundColor',
                      '|',
                      'LowerCase',
                      'UpperCase',
                      '|',
                      'Formats',
                      'Alignments',
                      'Blockquote',
                      '|',
                      'NumberFormatList',
                      'BulletFormatList',
                      '|',
                      'Outdent',
                      'Indent',
                      '|',
                      'CreateLink',
                      'Image',
                      'FileManager',
                      'Video',
                      'Audio',
                      'CreateTable',
                      '|',
                      'FormatPainter',
                      'ClearFormat',
                      '|',
                      'EmojiPicker',
                      'Print',
                      '|',
                      'SourceCode',
                      'FullScreen',
                    ],
                  }}
                  cssClass={`${role === 'provider' && 'dark-rte'}`}
                >
                  {showToolbar && onlyShowHTmlService && <Inject services={[HtmlEditor, Toolbar, Image, Link, QuickToolbar, Table, Video, Audio, PasteCleanup, ImportExport]} />}
                  {!showToolbar && onlyShowHTmlService && <Inject services={[HtmlEditor, Image, Link, QuickToolbar, Table, Video, Audio, PasteCleanup, ImportExport]} />}
                  {!onlyShowHTmlService && <Inject services={[HtmlEditor]} />}

                  {/* <Inject services={[HtmlEditor, Toolbar, Image, Link, QuickToolbar, Table, Video, Audio, PasteCleanup, ImportExport]} /> */}
                </RichTextEditorComponent>
              </div>
            </div>
          </div>
        </div>
      )}

      <CModal visible={visible} onClose={() => setVisible(false)} backdrop="static" keyboard={false} portal={false}>
        <CModalHeader onClose={() => setVisible(false)}>
          <CModalTitle>New Diagnosis</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-3">
            <CFormLabel>Select Diagnosis</CFormLabel>

            <Select
              placeholder="Select"
              onChange={(e) => {
                diagnosisChanged(e)
              }}
              options={diagnosisData}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={handleModalSave}>
            Add
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderLsPatientNoteViewFreetype

// <div style="margin:0;padding:0;margin-bottom:0pt">
// <p style="margin:0;padding:0;">Medications</p>
// <div style="margin:0;padding:0;">
//   ${currentOrder?.medication?.medication?.map((medItem) => {
//       const name = typeof medItem?.name === "object" ? JSON.stringify(medItem?.name) : medItem?.name || "";
//       const dosage = medItem?.dosage || "";
//       const route = medItem?.route || "";
//       const frequency = medItem?.frequency || "";
//       const reason = typeof medItem?.reason === "object" ? JSON.stringify(medItem?.reason) : medItem?.reason || "";
//       return `<p style="margin:0;padding:0;"">${name} ${dosage} ${route}${frequency ? ` ${frequency}` : ""}${reason ? ` - ${reason}` : ""}</p>`;
//   }).join("") || ""
//   }
// </div>
// </div>

// ${(customPEHtml || finalHtml || peGlobalRemark)
//   ? `
// <table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
//   <tr style="vertical-align: top;">
//     <td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">
//       Physical Examination
//     </td>
//     <td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
//       ${peGlobalRemark ? `<p>${peGlobalRemark}</p>` : ''}
//       ${customPEHtml ? customPEHtml : finalHtml || ''}
//     </td>
//   </tr>
// </table>

// <table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
//   <tr style="border:none; height:0; line-height:0;">
//     <td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
//   </tr>
// </table>
// `
//   : ''
// }
